import initDebug from 'debug';
import { __rest, __assign, __spreadArray, __makeTemplateObject, __awaiter, __generator } from 'tslib';
import React, { useMemo, useState, useRef, useEffect, useCallback, memo } from 'react';
import gql from 'graphql-tag';
import { AvatarLogo, SellerLabel, LabelCrew, Typography, Chip, colorPalette, Tooltip, LinkOrSpan, CircularIndeterminateCustom } from '@rakutenfrance/mui';
import { HelpIcon as HelpIcon$1, Help as Help$1, ClubR, Heart, PersonCheck, Person, Euro, Cart, ChevronLeft, ChevronRight } from '@rakutenfrance/shared-svg';
import { useMarketplace, T, MarketplaceFeature, useTranslate, tolgeeModule, getLanguageFromRequest, getTolgee, TolgeeProvider, MarketplaceProvider } from '@rakutenfrance/tolgee-provider';
import Autosuggest from 'react-autosuggest';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import { removeSpecialCharacters, env, debounce, computeSearchString, getActiveBanners, getActiveHighlights, getFilteredCampaigns, getActiveBanner, asyncLoadArrayProzessor } from '@rakutenfrance/shared-util';
import 'set-cookie-parser';
import 'cookie';
import { CSSTransition } from 'react-transition-group';
import Link from '@mui/material/Link';
import { useQuery, useMutation } from '@apollo/client';
import Badge from '@mui/material/Badge';
import { useGTM, GtmProvider } from '@rakutenfrance/gtm-provider';
import { HideInWebviewHoc } from '@rakutenfrance/shared-component';
import { connect } from 'react-redux';
import { useBreakpoint } from '@rakutenfrance/breakpoint';
import { publicRuntimeConfig, configService } from '@rakutenfrance/config-service';

var SHOW = 'header/SHOW';
var HIDE = 'header/HIDE';
var PERSIST_SEARCH = 'header/PERSIST_SEARCH';
var FOCUSED = 'header/FOCUSED';
var FETCH_HEADER_SUCCESS = 'header/FETCH_HEADER_SUCCESS';

var debug = initDebug('canopy:headerAction');
var show = function () { return ({
    type: SHOW,
}); };
var hide = function () { return ({
    type: HIDE,
}); };
var setFocus = function (status) { return ({
    type: FOCUSED,
    payload: status,
}); };
var persistHeaderSearch = function (searchKeywords) { return ({
    type: PERSIST_SEARCH,
    payload: searchKeywords,
}); };
var setIsHome = function (isHome) {
    debug('setIsHome start');
    return {
        type: FETCH_HEADER_SUCCESS,
        payload: {
            isHome: isHome,
        },
    };
};
var setHelpLink = function (helpLink) {
    debug('setIsHome start');
    return {
        type: FETCH_HEADER_SUCCESS,
        payload: {
            helpLink: helpLink,
        },
    };
};

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  show: show,
  hide: hide,
  setFocus: setFocus,
  persistHeaderSearch: persistHeaderSearch,
  setIsHome: setIsHome,
  setHelpLink: setHelpLink
});

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
var FILL_ACTIVE$1 = '#FFFFFF';
var FILL_INACTIVE$1 = '#828282';
function defaultIcon(icon) {
    return {
        icon: icon,
    };
}
var navMapping = new Map();
// nav button mapping
navMapping.set('help', defaultIcon(HelpIcon$1));
function svgMapper(uri, color) {
    if (color === void 0) { color = {}; }
    // trunk last part of the uri for get the literal name (useful for category mainly)
    var icons = /^.+\/(.+)\..+$/.exec(uri);
    // Return null if no match ( == simple icon)
    var checkInMap = icons ? icons[1] : uri;
    var elt = navMapping.get(checkInMap);
    if (elt === undefined) {
        /* Whatever it is, it just have to be a string. */
        return 'url';
    }
    elt.widthIcon = elt.width || undefined;
    elt.heightIcon = elt.height || undefined;
    elt.fillInactive = elt.fillInactive || color.inactive || FILL_INACTIVE$1;
    elt.fillActive = elt.fillActive || color.active || FILL_ACTIVE$1;
    return elt;
}

var FILL_ACTIVE = '#FFFFFF';
var FILL_INACTIVE = '#828282';
var SvgCompose = function (_a) {
    var width = _a.width, height = _a.height, className = _a.className; _a.sx; var iconUri = _a.iconUri, activeUri = _a.activeUri, _b = _a.active, active = _b === void 0 ? false : _b, color = _a.color, _c = _a.alt, alt = _c === void 0 ? 'img' : _c, categoryMapping = _a.categoryMapping, others = __rest(_a, ["width", "height", "className", "sx", "iconUri", "activeUri", "active", "color", "alt", "categoryMapping"]);
    // Memoize the child elements to avoid recreating them on every render
    var _d = useMemo(function () {
        var svgOrUrl = 'url';
        if (categoryMapping) {
            // Use category mapping for menu components
            var icons = /^.+\/(.+)\..+$/.exec(iconUri);
            var checkInMap = icons ? icons[1] : iconUri;
            var iconData = categoryMapping.get(checkInMap);
            if (iconData) {
                var icon = iconData.icon, fillInactive = iconData.fillInactive, fillActive = iconData.fillActive, widthIcon = iconData.widthIcon, heightIcon = iconData.heightIcon;
                var customWidth = width || widthIcon;
                var customHeight = height || heightIcon;
                return {
                    activeChild: React.createElement(icon, {
                        fill: fillActive || (color === null || color === void 0 ? void 0 : color.active) || FILL_ACTIVE,
                        width: customWidth,
                        height: customHeight,
                    }),
                    inactiveChild: React.createElement(icon, {
                        fill: fillInactive || (color === null || color === void 0 ? void 0 : color.inactive) || FILL_INACTIVE,
                        width: customWidth,
                        height: customHeight,
                    }),
                };
            }
        }
        else {
            // Use default nav mapping
            svgOrUrl = svgMapper(iconUri, color);
        }
        if (typeof svgOrUrl !== 'string') {
            var icon = svgOrUrl.icon, fillInactive = svgOrUrl.fillInactive, fillActive = svgOrUrl.fillActive, widthIcon = svgOrUrl.widthIcon, heightIcon = svgOrUrl.heightIcon;
            var customWidth = width || widthIcon;
            var customHeight = height || heightIcon;
            return {
                activeChild: React.createElement(icon, {
                    fill: fillActive,
                    width: customWidth,
                    height: customHeight,
                }),
                inactiveChild: React.createElement(icon, {
                    fill: fillInactive,
                    width: customWidth,
                    height: customHeight,
                }),
            };
        }
        else {
            return {
                activeChild: React.createElement("img", { width: width, height: height, alt: alt, src: activeUri }),
                inactiveChild: React.createElement("img", { width: width, height: height, alt: alt, src: iconUri }),
            };
        }
    }, [iconUri, activeUri, width, height, color, alt, categoryMapping]), activeChild = _d.activeChild, inactiveChild = _d.inactiveChild;
    // Use active prop directly to ensure SSR consistency
    var child = active ? activeChild : inactiveChild;
    return (React.createElement("span", __assign({ className: className }, others), child));
};

var s$d = {"container":"_h-container-ba6c","sellerCard--container":"_h-sellerCard--container-b1bb","iconCard":"_h-iconCard-dbb0","detailsCard":"_h-detailsCard-a631","title":"_h-title-df7f","text":"_h-text-12d4"};

var SellerCard = function (_a) {
    var seller = _a.seller, cashBackInfo = _a.cashBackInfo;
    var logo = seller.logo, name = seller.name, type = seller.type;
    return (React.createElement(Card, { variant: "outlined", className: "".concat(s$d.container, " sellerCard--container") },
        React.createElement(CardContent, { className: s$d.iconCard },
            React.createElement(AvatarLogo, { logoUrl: logo, height: "50px", width: "50px", iconSize: "25px", isSeller: true })),
        React.createElement(CardContent, { className: s$d.detailsCard },
            React.createElement("div", { className: s$d.title },
                React.createElement("span", { className: s$d.text }, name),
                type === 'SELLER_CREW' && React.createElement(SellerLabel, { label: "Site partenaire", isFrench: false })),
            type === 'SELLER_PRO' && React.createElement(SellerLabel, { label: "Pro", isFrench: false }),
            type === 'SELLER_CREW' && (cashBackInfo === undefined || cashBackInfo.isLoading) && React.createElement(Skeleton, { variant: "rounded", height: "23px", width: "100%" }),
            type === 'SELLER_CREW' && (cashBackInfo === null || cashBackInfo === void 0 ? void 0 : cashBackInfo.cashback) !== undefined && React.createElement(LabelCrew, { cashBack: cashBackInfo.cashback }))));
};

var canopyStyle = {"heading_4":"_h-heading_4-9fe1","text":"_h-text-8687","helper_flex-occupy":"_h-helper_flex-occupy-e1b0","helper_show-BelowDesktop":"_h-helper_show-BelowDesktop-e2a4","helper_hide-BelowPhone":"_h-helper_hide-BelowPhone-eebe","helper_hide-BelowTablet":"_h-helper_hide-BelowTablet-4a80","helper_hide-BelowWide":"_h-helper_hide-BelowWide-e2d1","helper_hide-BelowMax":"_h-helper_hide-BelowMax-622c","helper_hide-BelowDesktop":"_h-helper_hide-BelowDesktop-a0d1","helper_hide-BelowLandscape":"_h-helper_hide-BelowLandscape-a34a","header":"_h-header-914f","helper_hide-AboveTablet":"_h-helper_hide-AboveTablet-d187","z-10":"_h-z-10-e60c","sr-only":"_h-sr-only-ad12","grid_container":"_h-grid_container-cb42","grid_row":"_h-grid_row-b26a","col_nogutter":"_h-col_nogutter-e253","grid_col-2":"_h-grid_col-2-1a31","grid_col-4-BelowMax":"_h-grid_col-4-BelowMax-4fdb","grid_col-4-BelowDesktop":"_h-grid_col-4-BelowDesktop-34df","grid_col-8-BelowDesktop":"_h-grid_col-8-BelowDesktop-137c","b--gray-300":"_h-b--gray-300-db04","bb":"_h-bb-25ab","bn":"_h-bn-d78e","outline":"_h-outline-7b15","ba":"_h-ba-a08c","bt":"_h-bt-8f2c","br":"_h-br-f252","bl":"_h-bl-bc17","b--light-gray":"_h-b--light-gray-1877","br2":"_h-br2-bf2e","br3":"_h-br3-3a28","b--none":"_h-b--none-5295","top-0":"_h-top-0-cff1","cb":"_h-cb-2b94","db":"_h-db-56e7","dib":"_h-dib-4b11","flex":"_h-flex-d9eb","flex-spacing-1":"_h-flex-spacing-1-1775","flex-spacing-2":"_h-flex-spacing-2-3e58","flex-spacing-3":"_h-flex-spacing-3-d8f5","flex-spacing-4":"_h-flex-spacing-4-ca99","gap-8":"_h-gap-8-07cf","flex-auto":"_h-flex-auto-6512","flex-column":"_h-flex-column-25cc","items-start":"_h-items-start-fcc6","items-center":"_h-items-center-4b98","justify-center":"_h-justify-center-8000","justify-between":"_h-justify-between-a4cd","justify-around":"_h-justify-around-c24c","flex-column-ns":"_h-flex-column-ns-b027","flex-ns":"_h-flex-ns-5ef9","fl":"_h-fl-cefe","fr":"_h-fr-d91f","i":"_h-i-0fdd","normal":"_h-normal-b977","b":"_h-b-b9fe","h-100":"_h-h-100-c087","link":"_h-link-d4eb","list":"_h-list-2c01","w3":"_h-w3-39f5","w-50":"_h-w-50-5fdd","w-90":"_h-w-90-022e","w-100":"_h-w-100-1640","w-fit-content":"_h-w-fit-content-8bd9","overflow-hidden":"_h-overflow-hidden-a7e4","static":"_h-static-5efb","relative":"_h-relative-8234","absolute":"_h-absolute-74cd","fixed":"_h-fixed-c02d","gray-800":"_h-gray-800-4457","black":"_h-black-7f3e","near-black":"_h-near-black-4959","dark-gray":"_h-dark-gray-5b13","mid-gray":"_h-mid-gray-8d7b","gray":"_h-gray-5cee","silver":"_h-silver-2c4b","white":"_h-white-ffdd","blue":"_h-blue-8853","color-inherit":"_h-color-inherit-c4cf","bg-mid-gray":"_h-bg-mid-gray-8563","bg-white":"_h-bg-white-82a3","bg-red":"_h-bg-red-cd9b","hover-near-black":"_h-hover-near-black-406a","hover-bg-light-gray":"_h-hover-bg-light-gray-ec20","hover-bg-near-white":"_h-hover-bg-near-white-29eb","hover-bg-dark-red":"_h-hover-bg-dark-red-2a94","pa0":"_h-pa0-2b55","pa3":"_h-pa3-1016","pa4":"_h-pa4-c4f0","pl0":"_h-pl0-fc5c","pl1":"_h-pl1-8ad2","pl2":"_h-pl2-3367","pl3":"_h-pl3-14cf","pl4":"_h-pl4-6951","pl5":"_h-pl5-b6f2","pr3":"_h-pr3-0af2","pb1":"_h-pb1-48b7","pb3":"_h-pb3-dddc","pb4":"_h-pb4-72eb","pt1":"_h-pt1-d993","pt2":"_h-pt2-a0d8","pt3":"_h-pt3-1dc2","pt4":"_h-pt4-5173","pv3":"_h-pv3-1ff0","ph4":"_h-ph4-999a","ma0":"_h-ma0-6d8a","ma4":"_h-ma4-bf71","ml2":"_h-ml2-b3f6","ml3":"_h-ml3-4720","ml4":"_h-ml4-c52b","mr2":"_h-mr2-7a43","mr3":"_h-mr3-cb86","mb2":"_h-mb2-0add","mb4":"_h-mb4-5114","mt2":"_h-mt2-1662","mt3":"_h-mt3-eee5","mv0":"_h-mv0-1afa","mv2":"_h-mv2-23d1","mv4":"_h-mv4-2231","underline":"_h-underline-56b0","no-underline":"_h-no-underline-fc63","tc":"_h-tc-42b7","ttu":"_h-ttu-0f66","ttn":"_h-ttn-7aa4","f6":"_h-f6-495a","indent":"_h-indent-1beb","truncate":"_h-truncate-df37","center":"_h-center-3ad7","nowrap":"_h-nowrap-cc1d","v-top":"_h-v-top-0071","pointer":"_h-pointer-3207","textCursor":"_h-textCursor-dae3","z-1":"_h-z-1-e8a1","z-999":"_h-z-999-47e0","debug":"_h-debug-17d8","f3":"_h-f3-7d2a","f18":"_h-f18-affd","f14":"_h-f14-7394","f12":"_h-f12-02a0","pv-16":"_h-pv-16-1f30","ph-8":"_h-ph-8-31ec","ml-24":"_h-ml-24-fbd4","mt-8":"_h-mt-8-0f0c","pl-16-ns":"_h-pl-16-ns-4498","pr-16-ns":"_h-pr-16-ns-7e8b"};

var s$c = {"itemList":"_h-itemList-6237","category":"_h-category-ad62","lastCategory":"_h-lastCategory-3c4d"};

var Category = function (_a) {
    var _b = _a.category, category = _b === void 0 ? { label: '' } : _b, _c = _a.isLastCategory, isLastCategory = _c === void 0 ? false : _c;
    return (React.createElement("span", { className: "".concat(canopyStyle.black, " ").concat(canopyStyle.f6, " ").concat(s$c.category, " ").concat(isLastCategory && s$c.lastCategory) }, category.label));
};
var Keyword = function (_a) {
    var query = _a.query, keyword = _a.keyword;
    var cleanQuery = removeSpecialCharacters(query);
    var noBoldedKeyword = keyword;
    var boldedKeyword = null;
    if (keyword === null || keyword === void 0 ? void 0 : keyword.startsWith(cleanQuery)) {
        noBoldedKeyword = keyword.substr(0, cleanQuery.length);
        boldedKeyword = keyword.substr(cleanQuery.length);
    }
    return (React.createElement("span", { className: "".concat(canopyStyle.mr2) },
        noBoldedKeyword,
        boldedKeyword && React.createElement("b", null, boldedKeyword)));
};
var Suggestion = function (props, _a) {
    var query = _a.query;
    var keyword = props.keyword, category = props.category, isMobile = props.isMobile, isLastCategory = props.isLastCategory;
    if (isMobile && (category === null || category === void 0 ? void 0 : category.label)) {
        return (React.createElement("div", { className: "".concat(canopyStyle['hover-bg-near-white'], " ").concat(canopyStyle.pointer) },
            React.createElement(Category, { category: category, isLastCategory: isLastCategory })));
    }
    return (React.createElement("div", { className: "".concat(canopyStyle['dark-gray'], " ").concat(canopyStyle.f6, " ").concat(s$c.itemList, " ").concat(canopyStyle['hover-bg-near-white'], " ").concat(canopyStyle.pointer) },
        React.createElement(Keyword, { query: query, keyword: keyword }),
        React.createElement(Category, { category: category, isLastCategory: isLastCategory })));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
var Router = function (props, query, cashbacks) {
    if (props.type === 'KEYWORD') {
        return Suggestion(props, query);
    }
    else if (['SELLER_CREW', 'SELLER_PRO'].includes(props.type)) {
        var seller = props;
        return SellerCard({ seller: seller, cashBackInfo: cashbacks[seller.login] });
    }
    return React.createElement(React.Fragment, null, "Not supported");
};

var searchKeywords = {
    occasion: 'ft=u',
    reconditionne: 'ft=r',
    reconditionnes: 'ft=r',
    solde: 'cmp=sales',
    soldes: 'cmp=sales',
    soldé: 'cmp=sales',
};

const GEOLOC_PARAM = 'sh=pkp';

function addGeolocParameter(url) {
    return url && url.includes('?') ? "".concat(url, "&").concat(GEOLOC_PARAM) : "".concat(url, "?").concat(GEOLOC_PARAM);
}
function addHashParameter(url, param) {
    if (url && param) {
        return url && url.includes('#') ? "".concat(url, "&").concat(param) : "".concat(url, "#").concat(param);
    }
    return url;
}
function checkForFilterKeyword(searchUrl) {
    var _a, _b;
    if (searchUrl) {
        var url_1 = searchUrl;
        var urlSearchKeyword = url_1.slice(3);
        var vect = urlSearchKeyword.split('+');
        var keywordSize_1 = (_b = (_a = searchUrl.match(/\b\w+\b/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        var searching_1 = true;
        vect.forEach(function (str) {
            if (searching_1) {
                // @ts-expect-error str
                if (searchKeywords[str] && keywordSize_1 > 2) {
                    // @ts-expect-error str
                    url_1 = addHashParameter(searchUrl, searchKeywords[str]);
                    searching_1 = false;
                }
            }
        });
        return url_1;
    }
    return searchUrl;
}
function isInvalidInput(suggestionValue, categoryValue) {
    return (!suggestionValue || suggestionValue.trim() === '') && (!categoryValue || categoryValue.trim() === '');
}
var searchUtils = {
    checkForFilterKeyword: checkForFilterKeyword,
    addHashParameter: addHashParameter,
    addGeolocParameter: addGeolocParameter,
    isInvalidInput: isInvalidInput,
};

var SvgImg = function (_a) {
    var viewbox = _a.viewbox, title = _a.title, width = _a.width, height = _a.height, children = _a.children, _b = _a.extraClass, extraClass = _b === void 0 ? '' : _b, others = __rest(_a, ["viewbox", "title", "width", "height", "children", "extraClass"]);
    return (React.createElement("svg", __assign({ viewBox: viewbox, width: width, height: height, className: extraClass }, others),
        React.createElement("g", null,
            React.createElement("title", { id: "title" }, title)),
        children));
};
var SvgImg$1 = React.memo(SvgImg);

/* eslint-disable indent */
/* eslint-disable max-len */
var ZoomIcon = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.fill, fill = _b === void 0 ? '#828282' : _b;
    return (React.createElement(SvgImg$1, { width: width, height: height, viewbox: "0 0 43.09 43.64", title: "search" },
        React.createElement("g", { id: "Calque_2", "data-name": "Calque 2" },
            React.createElement("g", { id: "Calque_1-2", "data-name": "Calque 1", fill: fill },
                React.createElement("path", { d: "M42.51,40.28,30.17,27.94a17.26,17.26,0,1,0-2.86,2.71L39.73,43.06a2,2,0,1,0,2.78-2.78ZM25.14,28.47A14,14,0,1,1,28,25.76" })))));
};

function idify(title) {
    return (title || '').replace(/ /gi, '-');
}
var SvgIcon = function (_a) {
    var viewbox = _a.viewbox, title = _a.title, _b = _a.fill, fill = _b === void 0 ? '#828282' : _b, _c = _a.stroke, stroke = _c === void 0 ? 'none' : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? '1' : _d, children = _a.children, others = __rest(_a, ["viewbox", "title", "fill", "stroke", "strokeWidth", "children"]);
    return (
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; width?: string; height?... Remove this comment to see the full error message
    React.createElement(SvgImg$1, __assign({ viewbox: viewbox, title: title, fill: fill, stroke: stroke, strokeWidth: strokeWidth }, others),
        React.createElement("g", { id: "Symbols", stroke: stroke, strokeWidth: strokeWidth, fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: idify(title), fill: fill }, children))));
};

/* eslint-disable indent */
var SvgIcon24 = function (_a) {
    var _b = _a.viewbox, viewbox = _b === void 0 ? '0 0 24 24' : _b, others = __rest(_a, ["viewbox"]);
    return (
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ title?: string; string?: string | number; ... Remove this comment to see the full error message
    React.createElement(SvgIcon, __assign({ viewbox: viewbox }, others)));
};

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */
// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'Optional'.
var ChevronLeftIcon = function (_a) {
    var others = __rest(_a, []);
    return (React.createElement(SvgIcon24, __assign({ title: "icons / nav24 / chevron left" }, others),
        React.createElement("path", { d: "M12.5785173,12.0211459 L7.32684676,17.2728165 C6.89000935,17.7096539 6.89128668,18.4184991 7.32927694,18.8564894 L8.18580253,19.713015 C8.62367488,20.1508873 9.33282729,20.1520932 9.7694754,19.7154451 L16.6731532,12.8117673 C16.891168,12.5937525 17.0000588,12.3079872 17,12.0219532 C16.999935,11.7342401 16.8910737,11.4484451 16.6731532,11.2305246 L9.7694754,4.32684676 C9.33263799,3.89000935 8.62379279,3.89128668 8.18580253,4.32927694 L7.32927694,5.18580253 C6.89140459,5.62367488 6.89019865,6.33282729 7.32684676,6.7694754 L12.5785173,12.0211459 Z", id: "Combined-Shape", transform: "translate(12.000000, 12.021088) rotate(-180.000000) translate(-12.000000, -12.021088) " })));
};

var s$b = {"flex_grow":"_h-flex_grow-cbcc","mr_search":"_h-mr_search-d29c","brLeft":"_h-brLeft-f06a","brRight":"_h-brRight-3c16","defaultBorder":"_h-defaultBorder-81e2","wrapper":"_h-wrapper-4a9e","focused":"_h-focused-4571","suggested":"_h-suggested-ca3c","icon":"_h-icon-9331","button":"_h-button-66d4","search":"_h-search-f437","multicolumn":"_h-multicolumn-a550","sellersTitle":"_h-sellersTitle-20d3"};

var theme = {"cancelButton":"_h-cancelButton-841f","closeExpandedSuggest":"_h-closeExpandedSuggest-a382","suggestionsContainerOpen":"_h-suggestionsContainerOpen-ce4c","suggestionsList":"_h-suggestionsList-552c","suggestionHighlighted":"_h-suggestionHighlighted-b946","input":"_h-input-33ad","placeholderLabel":"_h-placeholderLabel-39a7","placeholderLabelBelowLandscape":"_h-placeholderLabelBelowLandscape-d851","placeholderLabelAboveLandscape":"_h-placeholderLabelAboveLandscape-4851","itemList":"_h-itemList-490f","visibleFocused":"_h-visibleFocused-d75f","placeholderLabelHiddenWithText":"_h-placeholderLabelHiddenWithText-e479"};

/**
 * [domainApi]
 * @return {[string]} - return the api base URL based on the environment the request is made
 */
function domainApi() {
    if (!env.isNode() && window.API_MANIFEST && window.API_MANIFEST.apiURL) {
        return window.API_MANIFEST.apiURL;
    }
    return '';
}

var glossaryTagQA = {
    header: {
        logo: 'header_logo',
        toolTip: {
            sell: 'sell_tooltip',
            help: 'help_tooltip',
            fav: 'fav_tooltip',
            account: 'account_tooltip',
            cart: 'cart_tooltip',
            priceclub: 'club_tooltip',
        },
        search: {
            button: 'search_button',
            input: 'search_input',
        },
    },
    hpv: {
        input: 'search-input',
        cta: 'search-cta',
        suggest: 'suggest',
    },
    lightHeader: {
        lightHeaderContainer: 'lightheader-container',
        logo: 'lightheader-logo-rakuten',
        clubR: 'lightheader-club-R',
        help: 'lightheade-aide',
        account: 'lightheader-mon-compte',
    },
};

var QaTracker = function (props) {
    var customClass = props.customClass, tagName = props.tagName, children = props.children;
    return (React.createElement("div", { className: customClass, "data-qa": tagName }, children));
};

initDebug('canopy:util');

initDebug('canopy:service');
var cleanEndPoint = function (ep) {
    var result = ep || '';
    while (result[result.length - 1] === '/') {
        result = result.slice(0, result.length - 1);
    }
    return result;
};
var extractUniverse = function (url) {
    return url.replace(/.*\//, '').replace(/(_|#|\?).*/, '');
};

var cache = {};
var cashbacksCache = {};
var getData = function (keywordInput, category, cb) {
    var path = "/restpublic/tech-web/searchAutoComplete/".concat(keywordInput, "?version=4");
    var host = cleanEndPoint(domainApi());
    var url = "".concat(host).concat(path);
    return fetch(url)
        .then(function (response) {
        cache[keywordInput] = [];
        return response
            .json()
            .then(function (data) {
            // @ts-expect-error errors
            if (response.status !== 200 || data.errors) {
                return [];
            }
            cache[keywordInput] = data;
            return data;
        })
            .catch(function () { return []; });
    })
        .catch(function () { return []; })
        .then(function (data) { return cb(data); });
};
var loadCashbackData = function (partnerKey, callback) {
    if (!cashbacksCache[partnerKey]) {
        var path = "/restpublic/web/eshop/landing/".concat(partnerKey, "/info");
        var host = cleanEndPoint(domainApi());
        var url = "".concat(host).concat(path);
        fetch(url)
            .then(function (response) {
            cashbacksCache[partnerKey] = { isLoading: true, cashback: undefined, isError: false };
            return response
                .json()
                .then(function (data) {
                if (response.status !== 200) {
                    cashbacksCache[partnerKey] = { isLoading: false, cashback: undefined, isError: true };
                }
                else {
                    cashbacksCache[partnerKey] = { isLoading: false, cashback: data.cashback, isError: false };
                }
            })
                .catch(function () {
                cashbacksCache[partnerKey] = { isLoading: false, cashback: undefined, isError: true };
            });
        })
            .catch(function () {
            cashbacksCache[partnerKey] = { isLoading: false, cashback: undefined, isError: true };
        })
            .finally(function () {
            callback(cashbacksCache);
        });
    }
};
// @ts-expect-error debounceData
var debounceData = debounce(getData, 50, false);
var getSuggestions = function (value, category) {
    return new Promise(function (resolve) {
        if (cache[value]) {
            return resolve(cache[value]);
        }
        // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 3.
        return debounceData(value, category.value, resolve);
    });
};
function shouldRenderSuggestions(value) {
    if (!value || typeof value !== 'string') {
        return false;
    }
    return value.trim().length > 0;
}
var Search = function (_a) {
    var placeholders = _a.placeholders; _a.location; var handlerFocus = _a.handlerFocus, _b = _a.internalSearchIsActive, internalSearchIsActive = _b === void 0 ? true : _b, persistedSearch = _a.persistedSearch, isNav = _a.isNav, storeHelper = _a.storeHelper, disableSuggest = _a.disableSuggest;
    // Get initial value with safe fallback
    var getInitialValue = function () {
        if (typeof window !== 'undefined' && window.INPUTSEARCHVALUE) {
            return window.INPUTSEARCHVALUE || '';
        }
        return '';
    };
    // State
    var category = useState({ value: undefined, label: null })[0];
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = useState(false), isFocused = _d[0], setIsFocused = _d[1];
    var _e = useState([]), suggestions = _e[0], setSuggestions = _e[1];
    var _f = useState(undefined), suggestion = _f[0], setSuggestion = _f[1];
    var _g = useState(''), value = _g[0], setValue = _g[1];
    var geolocEnabled = useState(undefined)[0];
    var _h = useState(false), isMobile = _h[0], setIsMobile = _h[1];
    var _j = useState(false), isHydrated = _j[0], setIsHydrated = _j[1];
    // Refs
    var loopRef = useRef(null);
    useEffect(function () {
        setIsHydrated(true);
        var initialValue = getInitialValue();
        setValue(initialValue);
    }, []);
    useEffect(function () {
        if (typeof window !== 'undefined') {
            var checkIsMobile_1 = function () { return window.innerWidth < 1199; };
            setIsMobile(checkIsMobile_1());
            var handleResize_1 = function () { return setIsMobile(checkIsMobile_1()); };
            window.addEventListener('resize', handleResize_1);
            return function () { return window.removeEventListener('resize', handleResize_1); };
        }
    }, []);
    useEffect(function () {
        var _a;
        if (!isHydrated)
            return;
        if (persistedSearch) {
            setValue(persistedSearch);
        }
        if (value !== '' || (typeof window !== 'undefined' && window.INPUTSEARCHHASFOCUS)) {
            (_a = document.querySelector('#header #PageForm input')) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isHydrated, persistedSearch]);
    useEffect(function () {
        if (!isNav && persistedSearch !== undefined && isHydrated) {
            setValue(persistedSearch);
        }
    }, [persistedSearch, isNav, isHydrated]);
    var onChange = useCallback(function (event, _a) {
        var newValue = _a.newValue;
        var safeValue = newValue || '';
        setValue(safeValue);
    }, []);
    var onSubmit = useCallback(function (category, suggestion, seller) {
        if (seller) {
            // @ts-expect-error ts-migrate(2322)
            window.location = seller.urlLink;
        }
        else if (suggestion) {
            var categoryValue = suggestion.category ? suggestion.category.value : category.value;
            if (searchUtils.isInvalidInput(suggestion.value, categoryValue)) {
                return null;
            }
            var searchBaseUrl = internalSearchIsActive ? 'search' : 's';
            var url = "/".concat(searchBaseUrl, "/").concat(computeSearchString(suggestion.value)).concat(categoryValue ? "?nav=".concat(categoryValue) : '');
            var searchUrl = geolocEnabled ? searchUtils.addGeolocParameter(url) : url;
            searchUrl = searchUtils.checkForFilterKeyword(searchUrl);
            if (storeHelper && storeHelper.hasSearch(searchUrl)) {
                storeHelper.search(searchUrl);
            }
            else {
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
                window.location = searchUrl;
            }
        }
        return null;
    }, [internalSearchIsActive, geolocEnabled, storeHelper]);
    // Ajax callback
    var onSuggestionsFetchRequested = useCallback(function (_a) {
        var value = _a.value;
        if (disableSuggest) {
            return;
        }
        getSuggestions(value, category).then(function (suggestionsData) {
            var autocomplete = suggestionsData.listDto.reduce(function (res, suggestion) {
                if (!suggestion.categories || isMobile) {
                    res.push({
                        type: 'KEYWORD',
                        keyword: suggestion.keyword,
                        value: suggestion.value,
                        category: {
                            label: null,
                            value: undefined,
                        },
                        // @ts-expect-error resultCount
                        resultCount: suggestion.resultCount,
                    });
                }
                if (suggestion.categories) {
                    suggestion.categories.forEach(function (category) {
                        return res.push({
                            type: 'KEYWORD',
                            keyword: suggestion.keyword,
                            category: {
                                label: category.label,
                                value: category.value,
                            },
                            value: suggestion.value,
                            resultCount: category.resultCount,
                            isMobile: isMobile,
                            // @ts-expect-error error
                            isLastCategory: suggestion.categories[suggestion.categories.length - 1] === category,
                        });
                    });
                }
                return res;
            }, []);
            var sellersProFront = suggestionsData.sellersProFront, sellersCrew = suggestionsData.sellersCrew;
            var MAX_SELLERS_CARD = isMobile ? 1 : 2;
            var sellersCrewResult = (sellersCrew === null || sellersCrew === void 0 ? void 0 : sellersCrew.map(function (s) { return (__assign(__assign({}, s), { type: 'SELLER_CREW' })); }).slice(0, MAX_SELLERS_CARD)) || [];
            var sellersProResult = (sellersProFront === null || sellersProFront === void 0 ? void 0 : sellersProFront.map(function (s) { return (__assign(__assign({}, s), { type: 'SELLER_PRO' })); }).slice(0, MAX_SELLERS_CARD)) || [];
            sellersCrewResult.forEach(function (seller) { return loadCashbackData(seller.login, function () { }); });
            var sellersProTitle = sellersProResult.length > 1 ? 'boutiques ' : sellersProResult.length > 0 ? 'boutique ' : undefined;
            var sellersCrewTitle = sellersCrewResult.length > 1 ? 'sites partenaires ' : sellersCrewResult.length > 0 ? 'site partenaire ' : undefined;
            var result = [
                {
                    type: 'KEYWORDS',
                    items: autocomplete,
                },
                {
                    type: 'SELLERS',
                    title: (React.createElement("div", { className: s$b.sellersTitle },
                        [sellersProTitle, sellersCrewTitle].filter(function (t) { return t; }).join('et '),
                        "pour \"",
                        React.createElement("b", null, value),
                        "\"")),
                    items: __spreadArray(__spreadArray([], sellersProResult, true), sellersCrewResult, true),
                },
            ].filter(function (e) { var _a; return (_a = e.items) === null || _a === void 0 ? void 0 : _a.length; });
            setSuggestions(isMobile ? result.reverse() : result);
            setIsOpen(true);
        });
    }, [category, disableSuggest]);
    var onKeyDown = useCallback(function (event) {
        if (event.key === 'Enter') {
            setTimeout(function () {
                if (suggestion && suggestion.type === 'KEYWORD') {
                    var keywordSuggestion = suggestion;
                    keywordSuggestion.value = keywordSuggestion.value || value;
                    onSubmit(category, keywordSuggestion);
                }
                else if (suggestion && (suggestion.type === 'SELLER_PRO' || suggestion.type === 'SELLER_CREW')) {
                    var sellerItem = suggestion;
                    // @ts-expect-error window
                    window.location = sellerItem.urlLink;
                }
                else if (value) {
                    onSubmit(category, { type: 'KEYWORD', value: value });
                }
            }, 0);
            // loose focus
            event.preventDefault();
            focus();
        }
        else {
            setIsFocused(true);
            setIsOpen(true);
            handlerFocus(true);
        }
    }, [suggestion, value, category, onSubmit, handlerFocus]);
    var onSuggestionSelected = useCallback(function (
    // @ts-expect-error event
    event, _a) {
        var method = _a.method, suggestion = _a.suggestion;
        if (method === 'click') {
            setTimeout(function () {
                var autosuggest = (suggestion === null || suggestion === void 0 ? void 0 : suggestion.type) === 'KEYWORD' ? suggestion : undefined;
                var seller = (suggestion === null || suggestion === void 0 ? void 0 : suggestion.type) === 'SELLER_PRO' || (suggestion === null || suggestion === void 0 ? void 0 : suggestion.type) === 'SELLER_CREW' ? suggestion : undefined;
                onSubmit(category, autosuggest, seller);
            }, 0);
        }
    }, [category, onSubmit]);
    // When erase requests
    var onSuggestionsClearRequested = useCallback(function () {
        setSuggestions([]);
        setSuggestion(undefined);
        // For the front behavior when small
        // handlerFocus(false);
        onFocusChange(false);
    }, []);
    var setOutline = useCallback(function (status) {
        setIsFocused(status);
        setIsOpen(status);
        if (status) {
            onFocusChange(true);
        }
    }, []);
    var onFocusChange = useCallback(function (status) {
        handlerFocus(status);
        if (storeHelper) {
            storeHelper.setFocus(status);
        }
    }, [handlerFocus, storeHelper]);
    var focus = useCallback(function () {
        if (loopRef.current) {
            loopRef.current.focus();
        }
    }, []);
    var inputProps = {
        value: value || '',
        onChange: onChange,
        onKeyDown: onKeyDown,
        name: 'searchField',
        id: 'searchField',
    };
    var getSuggestionValue = useCallback(function (suggestion) {
        setSuggestion(suggestion);
        var result = suggestion.type === 'KEYWORD' ? suggestion.keyword : suggestion.name;
        return result || '';
    }, []);
    var handleSearchButtonClick = useCallback(function () {
        var currentSuggestion = (suggestion === null || suggestion === void 0 ? void 0 : suggestion.type) === 'KEYWORD' ? suggestion : undefined;
        var seller = (suggestion === null || suggestion === void 0 ? void 0 : suggestion.type) === 'SELLER_PRO' || (suggestion === null || suggestion === void 0 ? void 0 : suggestion.type) === 'SELLER_CREW' ? suggestion : undefined;
        return onSubmit(category, (currentSuggestion === null || currentSuggestion === void 0 ? void 0 : currentSuggestion.value) ? currentSuggestion : { value: value, type: 'KEYWORD' }, seller);
    }, [suggestion, category, value, onSubmit]);
    return (React.createElement("div", { className: "_hy ".concat(canopyStyle.flex, " ").concat(canopyStyle.br3, "\n        ").concat(suggestions.length > 1 ? s$b.suggested : '', "\n        ").concat(isFocused ? s$b.defaultBorder : null, "\n        ").concat(isFocused ? s$b.focused : '', "\n        ").concat(s$b.wrapper, "\n        ").concat(s$b.flex_grow, "\n        ").concat(s$b.mr_search, "\n        ").concat(s$b.defaultBorder, "\n        ").concat(canopyStyle.br3, "\n        ").concat(canopyStyle.ml3, "\n        "), style: {
            backgroundColor: 'green',
            // paddingLeft: '10px',
            // marginLeft: '10px',
        }, onFocus: function () { return setOutline(true); }, onBlur: function () { return setOutline(false); } },
        isOpen && (React.createElement("button", { className: "_hy ".concat(canopyStyle.white, " ").concat(canopyStyle.bn, " ").concat(canopyStyle.br2, " ").concat(s$b.brLeft, " ").concat(canopyStyle['bg-white'], " ").concat(canopyStyle['helper_show-BelowDesktop'], " ").concat(s$b.button), type: "button", onClick: onSuggestionsClearRequested },
            React.createElement(ChevronLeftIcon, { width: "16px", height: "16px" }))),
        React.createElement("form", { className: "_hy ".concat(canopyStyle.flex, " ").concat(canopyStyle['helper_flex-occupy'], " ").concat(s$b.search, " ").concat(canopyStyle.relative), id: "PageForm", action: "/s" },
            React.createElement(QaTracker, { customClass: "".concat(canopyStyle.flex, " ").concat(canopyStyle['helper_flex-occupy'], " ").concat(canopyStyle.relative), tagName: glossaryTagQA.header.search.input },
                React.createElement(Autosuggest, { suggestions: suggestions, theme: theme, onSuggestionSelected: onSuggestionSelected, onSuggestionsClearRequested: onSuggestionsClearRequested, onSuggestionsFetchRequested: onSuggestionsFetchRequested, getSuggestionValue: getSuggestionValue, renderSuggestion: function () {
                        var props = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            props[_i] = arguments[_i];
                        }
                        return Router.apply(void 0, __spreadArray(__spreadArray([], props, false), [cashbacksCache], false));
                    }, inputProps: inputProps, shouldRenderSuggestions: shouldRenderSuggestions, focusInputOnSuggestionClick: false, multiSection: true, renderSectionTitle: function (section) { return section.title; }, getSectionSuggestions: function (section) { return (section === null || section === void 0 ? void 0 : section.items) || []; }, renderSuggestionsContainer: function (_a) {
                        var containerProps = _a.containerProps, children = _a.children;
                        return (React.createElement("div", __assign({}, containerProps, { className: "".concat(containerProps.className, " ").concat(suggestions.length > 1 && s$b.multicolumn) }), children));
                    } }),
                React.createElement("label", { htmlFor: "searchField", className: "\n              _hy\n              ".concat(theme.placeholderLabelAboveLandscape, "\n              ").concat(theme.placeholderLabel, "\n              ").concat(value !== null && value !== '' ? theme.placeholderLabelHiddenWithText : '', "\n              ").concat(canopyStyle.textCursor, "\n              ") },
                    React.createElement(T, { ns: "header", keyName: "header_search_placeholders_".concat(isMobile ? 'small' : 'large') }, placeholders[isMobile ? 'small' : 'large'])))),
        React.createElement("button", { type: "button", className: "".concat(canopyStyle['bg-mid-gray'], " ").concat(canopyStyle.pointer, " ").concat(canopyStyle.flex, " ").concat(canopyStyle.white, " ").concat(canopyStyle.br2, " ").concat(canopyStyle.bn, " ").concat(s$b.brRight, " ").concat(s$b.button), ref: loopRef, "data-qa": glossaryTagQA.header.search.button, onClick: handleSearchButtonClick },
            React.createElement(ZoomIcon, { fill: "#ffffff", width: "16px", height: "16px" }))));
};
// Fix to not mix react 15 context (storehelper) and react 16 context (breakpoint) in 1 component, this is not possible
var SearchWrapperBreakpointContextToProps = function (props) {
    var isInTargetMarkets = useMarketplace(['fr']).isInTargetMarkets;
    return React.createElement(Search, __assign({}, props, { disableSuggest: !isInTargetMarkets }));
};

/**
 * Get Input value from the Header search field
 */
function getInputSearchValue() {
    // hack to catch input value from search input field prior header component render
    var el = document.querySelector('#header #PageForm input');
    var body = document.querySelector('body');
    if (el && body) {
        window.INPUTSEARCHVALUE = el.value;
        el.addEventListener('change', function (event) {
            window.INPUTSEARCHVALUE = event.target.value;
        });
        window.INPUTSEARCHHASFOCUS = document.activeElement === el;
        el.addEventListener('click', function () {
            window.INPUTSEARCHHASFOCUS = true;
        });
        body.addEventListener('click', function (event) {
            if (event.target !== el) {
                window.INPUTSEARCHHASFOCUS = false;
            }
        });
    }
}
if (!env.isNode()) {
    getInputSearchValue();
}

/* eslint-disable indent */
/* eslint-disable max-len */
var WaitingIcon = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.fill, fill = _b === void 0 ? '#0099ff' : _b;
    return (React.createElement(SvgImg$1, { width: width, height: height, viewbox: "0 0 300 300", title: "waiting" },
        React.createElement("path", { d: "M 150,0 a 150,150 0 0,1 106.066,256.066 l -35.355,-35.355 a -100,-100 0 0,0 -70.711,-170.711 z", fill: fill })));
};

var s$a = {"main":"_h-main-4179","spinner":"_h-spinner-1106"};

var Loader = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 2.1 : _b, _c = _a.fill, fill = _c === void 0 ? 'gray' : _c, _d = _a.classNameLoader, classNameLoader = _d === void 0 ? '' : _d;
    var loader = (React.createElement("div", { className: classNameLoader },
        React.createElement("div", { style: { width: "".concat(size, "rem"), height: "".concat(size, "rem") }, className: "".concat(canopyStyle['overflow-hidden'], " ").concat(s$a.main) },
            React.createElement(WaitingIcon, { fill: fill }),
            React.createElement("span", { className: canopyStyle['sr-only'] }, "Loading..."))));
    return loader;
};

function Async(_a) {
    var promise = _a.promise, _b = _a.loading, loading = _b === void 0 ? null : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.classNameLoader, classNameLoader = _d === void 0 ? '' : _d, _e = _a.loaderSize, loaderSize = _e === void 0 ? 2.1 : _e, otherProps = __rest(_a, ["promise", "loading", "className", "classNameLoader", "loaderSize"]);
    var _f = useState(undefined), component = _f[0], setComponent = _f[1];
    var cancelUpdateRef = useRef(false);
    useEffect(function () {
        cancelUpdateRef.current = false;
        promise
            .then(function (c) {
            if (!cancelUpdateRef.current) {
                setComponent(function () { return c.default || c; });
            }
        })
            .catch(function (error) {
            console.error('Error loading async component:', error);
        });
        return function () {
            cancelUpdateRef.current = true;
        };
    }, [promise]);
    if (!component) {
        return loading || React.createElement(Loader, { classNameLoader: "".concat(classNameLoader, " loading"), size: loaderSize });
    }
    var Component = component;
    return React.createElement(Component, __assign({ className: className }, otherProps));
}

var n = {"icons":"_h-icons-53dc"};

var BurgerIcon = function (_a) {
    var _b = _a.burgerBackgroundColor, burgerBackgroundColor = _b === void 0 ? 'transparent' : _b, _c = _a.lineColor, lineColor = _c === void 0 ? '#333' : _c, _d = _a.width, width = _d === void 0 ? 40 : _d, _e = _a.height, height = _e === void 0 ? 40 : _e; _a.strokeWidth; var _g = _a.animationDuration, animationDuration = _g === void 0 ? 0.4 : _g, _h = _a.isOpen, isOpen = _h === void 0 ? false : _h;
    var _width = "".concat(width, "px");
    var _height = "".concat(height, "px");
    var oneThirdHeight = "".concat(Math.ceil(parseInt(_height.replace('px', ''), 10) / 3), "px");
    var getTransformValue = function (openVal, translateVal, rotateVal) {
        return "translateY(".concat(isOpen ? translateVal : '0', ") rotate(").concat(openVal ? "".concat(rotateVal, "deg") : '0', ")");
    };
    var styles = {
        container: {
            width: _width,
            height: _height,
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        lineBase: {
            width: _width,
            backgroundColor: lineColor,
            transformOrigin: 'center',
            transitionTimingFunction: 'ease',
            transitionDuration: "".concat(animationDuration, "s"),
            border: "1px solid ".concat(lineColor),
        },
        LineBaseCtn: {
            backgroundColor: burgerBackgroundColor,
            transform: getTransformValue(isOpen, 0, 135),
            transitionTimingFunction: 'ease',
            transitionDuration: "".concat(animationDuration, "s"),
            transitionProperty: 'all',
        },
        firstLine: {
            transform: getTransformValue(isOpen, oneThirdHeight, 90),
        },
        secondLine: {
            transitionTimingFunction: 'ease-out',
            transitionDuration: "".concat(animationDuration / 4, "s"),
        },
        thirdLine: {
            // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
            transform: getTransformValue(isOpen, 90),
            transitionDuration: "".concat(animationDuration / 10, "s"),
            opacity: isOpen ? '0' : '1',
        },
    };
    return (
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ width: string; height: string; position: s... Remove this comment to see the full error message
    React.createElement("div", { style: styles.container, className: n.icons },
        React.createElement("div", { style: styles.LineBaseCtn, className: "".concat(canopyStyle.flex, " ").concat(canopyStyle.pointer, " ").concat(canopyStyle.relative, " ").concat(canopyStyle['flex-spacing-2'], " ").concat(canopyStyle['flex-column']) },
            React.createElement("span", { className: "".concat(canopyStyle.db, " "), style: Object.assign({}, styles.lineBase, styles.firstLine) }),
            React.createElement("span", { className: "".concat(canopyStyle.db, " "), style: Object.assign({}, styles.lineBase, styles.secondLine) }),
            React.createElement("span", { className: "".concat(canopyStyle.db, " "), style: Object.assign({}, styles.lineBase, styles.thirdLine) }))));
};

var o = {"root":"_h-root-cbf4","container":"_h-container-5324","navMenuButton":"_h-navMenuButton-dcb2","label":"_h-label-6a7a","wrapperOpen":"_h-wrapperOpen-9603","labelClose":"_h-labelClose-f5d0","wrapperClose":"_h-wrapperClose-3375","labelOpen":"_h-labelOpen-b5d6"};

var NavMenuButton = function (_a) {
    var labels = _a.labels, isOpen = _a.isOpen, onClick = _a.onClick, onHoverIn = _a.onHoverIn, onHoverOut = _a.onHoverOut;
    return (React.createElement("div", { className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['pointer'], " ").concat(canopyStyle['w-fit-content']), onMouseEnter: onHoverIn, onMouseLeave: onHoverOut, onClick: onClick, "data-qa": "navigationButton" },
        React.createElement("div", { role: "button", className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['items-center']) },
            React.createElement(BurgerIcon, { isOpen: isOpen, width: 24, height: 24 }),
            React.createElement("div", { className: o.navMenuButton, "data-qa": "nav-menu-button-text" },
                React.createElement(Typography, { component: "span", variant: "body-default-semibold", className: "".concat(o.label, " ").concat(isOpen ? o.wrapperClose : o.wrapperOpen, " ").concat(canopyStyle['helper_hide-BelowDesktop'], " ").concat(canopyStyle.nowrap) },
                    React.createElement(Typography, { component: "span", variant: "body-default-semibold", className: "".concat(o.labelClose, " ").concat(canopyStyle['dark-gray']) },
                        React.createElement(T, { ns: "header", keyName: "menu_close" }, labels.close)),
                    React.createElement(Typography, { component: "span", variant: "body-default-regular", className: "".concat(o.labelOpen, " ").concat(canopyStyle['dark-gray']), sx: {
                            fontWeight: 600,
                        } },
                        React.createElement(T, { ns: "header", keyName: "menu_large" }, labels.large)))))));
};

var NavStatic = {
    profile: {
        actionsTotalCount: 0,
        labels: {
            large: 'Se connecter',
            small: 'Compte',
        },
        icon: 'profile',
        link: '/user',
        connectLink: '/connect?action=login',
        merchantCenterLink: '/merchant-center',
    },
    cart: {
        labels: {
            default: '',
        },
        link: '/cart?o=1',
        icon: 'cart',
    },
    favorites: {
        labels: {
            large: '',
            small: '',
        },
        link: '/memo?action=list',
        icon: 'heart',
    },
    priceclub: {
        labels: {
            icon: {
                max: 'https://images.fr.shopping.rakuten.com/visuels/Club-Rakuten/icon/club-rd1.svg',
                desktop: 'https://images.fr.shopping.rakuten.com/visuels/Club-Rakuten/icon/club-rd1.svg',
            },
        },
        link: '/event/club-rakuten',
        isMemberLink: '/user/club',
    },
    help: {
        labels: {
            large: 'Aide',
            small: 'Aide',
        },
        link: '/newhelp/',
        icon: 'help',
    },
    sales: {
        labels: {
            large: 'Mettre en vente',
            small: 'Vendre',
        },
        link: '/v/vendre',
        sellHomeLink: '/seller/sell-form',
        icon: 'sell',
    },
    menu: {
        labels: {
            large: 'Parcourir les catégories',
            small: 'Menu',
            close: 'Fermer',
        },
    },
};

var r = {"navWrapper":"_h-navWrapper-c862","loader":"_h-loader-1b46","helpWrapper":"_h-helpWrapper-d388","highlightsBlock":"_h-highlightsBlock-75e3"};

var s$9 = {"highlightsWrapper":"_h-highlightsWrapper-ea77","chipContainer":"_h-chipContainer-ccc4","blur":"_h-blur-34ac"};

function truncateString(str, num) {
    if (str.length <= num) {
        return str;
    }
    return "".concat(str.slice(0, num), "...");
}

var Highlights = function (_a) {
    var highlightsProp = _a.highlights;
    var _b = useState(false), isMobile = _b[0], setIsMobile = _b[1];
    useEffect(function () {
        var checkMobile = function () {
            setIsMobile(window.innerWidth < 1200);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return function () {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);
    return (React.createElement("div", { className: s$9.highlightsWrapper },
        React.createElement("div", { className: s$9.chipContainer }, highlightsProp &&
            highlightsProp.map(function (item, i) {
                var _a, _b, _c, _d;
                var isLongTitle = (_a = item.creation) === null || _a === void 0 ? void 0 : _a.titre_long;
                var title = isMobile ? (_b = item === null || item === void 0 ? void 0 : item.creation) === null || _b === void 0 ? void 0 : _b.titre_highlight_mobile : (_c = item === null || item === void 0 ? void 0 : item.creation) === null || _c === void 0 ? void 0 : _c.titre_highlight_desktop;
                if (!title) {
                    return null;
                }
                var highlightTitle = isLongTitle ? title : truncateString(title !== null && title !== void 0 ? title : '', 25);
                return (React.createElement(Link, { key: "".concat(item.id, "-").concat(i), href: (_d = item.creation) === null || _d === void 0 ? void 0 : _d.lien_highlight },
                    React.createElement(Chip, { label: highlightTitle, bold: true, sx: {
                            height: '32px',
                            color: colorPalette.gray900,
                        } })));
            })),
        React.createElement("div", { className: s$9.blur })));
};

var Nav$1 = function (_a) {
    var menu = _a.menu, _b = _a.helpLink, helpLink = _b === void 0 ? NavStatic.help.link : _b, highlights = _a.highlights;
    var isInFrenchPlatform = useMarketplace(['fr']);
    var _c = useState(false), isMobile = _c[0], setIsMobile = _c[1];
    useEffect(function () {
        if (typeof window === 'undefined')
            return;
        var checkIsMobile = function () { return window.innerWidth < 992; };
        setIsMobile(checkIsMobile());
        var handleResize = function () { return setIsMobile(checkIsMobile()); };
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    useEffect(function () {
        if (window.convertSpan) {
            window.convertSpan();
        }
    });
    return (React.createElement("nav", { className: "".concat(canopyStyle['bg-white'], " ").concat(canopyStyle.flex, " ").concat(canopyStyle['items-center'], " ").concat(r.navWrapper) },
        React.createElement(MarketplaceFeature, { marketplaces: ['fr', 'es', 'de', 'it', 'pt'] },
            React.createElement(NavMenuButton, { labels: NavStatic.menu.labels, isOpen: menu.isOpen, onClick: menu.onClick, onHoverIn: isMobile ? undefined : menu.onHoverIn, onHoverOut: isMobile ? undefined : menu.onHoverOut })),
        React.createElement("div", { className: r.highlightsBlock }, isInFrenchPlatform.isInTargetMarkets && React.createElement(Highlights, { highlights: highlights })),
        React.createElement("a", { "data-qa": "".concat(glossaryTagQA.header.toolTip.help, " navigationButton"), className: "".concat(r.helpWrapper, " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['flex-spacing-2'], " ").concat(canopyStyle['f18'], " ").concat(canopyStyle['dark-gray'], " ").concat(canopyStyle['no-underline']), href: helpLink },
            React.createElement(Typography, { variant: "body-default-regular" }, "Aide"),
            React.createElement(Help$1, { width: "24", height: "24" }))));
};

var s$8 = {"wrapper":"_h-wrapper-9186"};

var ShowMenu = function (props) {
    return (React.createElement(Async, __assign({ promise: import(
        /* webpackChunkName: "Menu" */
        /* webpackMode: "lazy" */
        './index-5b589122.js') }, props)));
};
var NavAndMenuCtn = function (props) {
    var personalized = props.personalized, md = props.md, menu = props.menu, searchHasFocus = props.searchHasFocus, helpLink = props.helpLink, displayLink = props.displayLink, universe = props.universe, storeHelper = props.storeHelper, highlights = props.highlights, others = __rest(props, ["personalized", "md", "menu", "searchHasFocus", "helpLink", "displayLink", "universe", "storeHelper", "highlights"]);
    var _a = useState(false), menuOpened = _a[0], setMenuOpened = _a[1];
    var _b = useState(false), mouseOverMenu = _b[0], setMouseOverMenu = _b[1];
    var menuNodeRef = useRef(null);
    // Use refs to store the latest state values for use in timeouts
    var mouseOverMenuRef = useRef(mouseOverMenu);
    var menuOpenedRef = useRef(menuOpened);
    // Update refs when state changes
    useEffect(function () {
        mouseOverMenuRef.current = mouseOverMenu;
    }, [mouseOverMenu]);
    useEffect(function () {
        menuOpenedRef.current = menuOpened;
    }, [menuOpened]);
    var forceCloseMenu = useCallback(function () {
        setTimeout(function () {
            setMenuOpened(false);
            setMouseOverMenu(false);
        }, 50);
    }, []);
    var closeMenu = useCallback(function () {
        setTimeout(function () {
            if (!mouseOverMenuRef.current) {
                setMenuOpened(false);
                setMouseOverMenu(false);
            }
        }, 100);
    }, []);
    var openMenu = useCallback(function () {
        if (!menuOpenedRef.current && mouseOverMenuRef.current) {
            setMenuOpened(true);
        }
    }, []);
    var willOpenMenu = useCallback(function () {
        setTimeout(function () {
            openMenu();
        }, 300);
    }, [openMenu]);
    var onMenuClick = useCallback(function () {
        setMenuOpened(function (prev) { return !prev; });
    }, []);
    var onMouseLeaveMenu = useCallback(function () {
        setMouseOverMenu(false);
        closeMenu();
    }, [closeMenu]);
    var onMouseEnterMenu = useCallback(function () {
        setMouseOverMenu(true);
        willOpenMenu();
    }, [willOpenMenu]);
    useEffect(function () {
        storeHelper.defineCloseMenu(forceCloseMenu);
        return function () {
            storeHelper.defineCloseMenu(function () { });
        };
    }, [storeHelper, forceCloseMenu]);
    useEffect(function () {
        if (searchHasFocus && menuOpened) {
            forceCloseMenu();
        }
    }, [searchHasFocus, menuOpened, forceCloseMenu]);
    var renderIE = useCallback(function (navMenuButtonProps) {
        return (React.createElement("div", { className: "".concat(canopyStyle.mt2, " ").concat(canopyStyle.mb2, " ").concat(canopyStyle['z-10']) },
            React.createElement(Nav$1, __assign({ personalized: personalized }, others, { 
                /* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */
                displayLink: displayLink, menu: navMenuButtonProps, highlights: highlights })),
            menuOpened && (React.createElement("div", { className: "".concat(canopyStyle.relative, " ").concat(canopyStyle['z-999']) },
                React.createElement(ShowMenu, { classNameLoader: "".concat(s$8.wrapper, " ").concat(canopyStyle.absolute, " ").concat(canopyStyle.flex), 
                    // isOpened={menuOpened}
                    categories: menu.categories, onMouseEnterMenu: onMouseEnterMenu, onMouseLeaveMenu: onMouseLeaveMenu, onOutsideClick: closeMenu, displayLink: displayLink, universe: universe, storeHelper: storeHelper, md: md })))));
    }, [
        personalized,
        others,
        displayLink,
        menuOpened,
        menu.categories,
        onMouseEnterMenu,
        onMouseLeaveMenu,
        closeMenu,
        universe,
        storeHelper,
        md,
        highlights,
    ]);
    var navMenuButtonProps = {
        isOpen: menuOpened,
        onClick: onMenuClick,
        onHoverIn: onMouseEnterMenu,
        onHoverOut: onMouseLeaveMenu,
        // labels: menu.labels,
    };
    if (md.ie) {
        return renderIE(navMenuButtonProps);
    }
    return (
    // <div className={`${canopyStyle.mt2} ${canopyStyle.mb2} ${canopyStyle['z-10']}`}>
    React.createElement("div", { className: "".concat(canopyStyle['z-10']) },
        React.createElement(Nav$1, __assign({ personalized: personalized, md: md }, others, { 
            /* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */
            displayLink: displayLink, menu: navMenuButtonProps, 
            /* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */
            helpLink: helpLink, highlights: highlights })),
        React.createElement(CSSTransition, { in: menuOpened, nodeRef: menuNodeRef, classNames: "menuCtn", timeout: {
                enter: 500,
                exit: md.mobile ? 500 : 50,
            }, mountOnEnter: true, unmountOnExit: true },
            React.createElement("div", { className: "".concat(canopyStyle.relative, " ").concat(canopyStyle['z-999']), ref: menuNodeRef },
                React.createElement(ShowMenu, __assign({ classNameLoader: "".concat(s$8.wrapper, " ").concat(canopyStyle.absolute, " ").concat(canopyStyle.flex) }, menu, { onMouseEnterMenu: onMouseEnterMenu, onMouseLeaveMenu: onMouseLeaveMenu, onOutsideClick: closeMenu, displayLink: displayLink, universe: universe, storeHelper: storeHelper, md: md }))))));
};

var s$7 = {"wrapper":"_h-wrapper-4301","icon":"_h-icon-02ab","status":"_h-status-05a5","content-status":"_h-content-status-f6ab","priceClub":"_h-priceClub-28df","platinum":"_h-platinum-ceaf","gold":"_h-gold-9b9b","regular":"_h-regular-db16","silver":"_h-silver-2902","status-label":"_h-status-label-0cab","status-label-value":"_h-status-label-value-7461","status-label-use":"_h-status-label-use-c2a4","capitalize":"_h-capitalize-0285","color-platinum":"_h-color-platinum-a200","color-gold":"_h-color-gold-124f","color-regular":"_h-color-regular-1491","color-silver":"_h-color-silver-112d","centered":"_h-centered-206e","status-details-label":"_h-status-details-label-e6b1","price-club-tooltip-element":"_h-price-club-tooltip-element-5af6","right-arrow":"_h-right-arrow-2ab5","status-label-euro":"_h-status-label-euro-9fb5","tooltipElementContainer":"_h-tooltipElementContainer-5b85","elementContent":"_h-elementContent-9db9","contentTitle":"_h-contentTitle-b7af","rightArrowContainer":"_h-rightArrowContainer-e70f","widthAuto":"_h-widthAuto-aac0","clubRTapzone":"_h-clubRTapzone-e668","chip":"_h-chip-3c26"};

var tooltipStyle = {"wrapper":"_h-wrapper-4daa","wrapper-default":"_h-wrapper-default-a0e7","breakLine":"_h-breakLine-0ce3","mainBlock":"_h-mainBlock-25c8","line":"_h-line-2821","tooltipTitleBox":"_h-tooltipTitleBox-356e","salesTooltipTitleBox":"_h-salesTooltipTitleBox-61a8","tabZone":"_h-tabZone-69f9","tooltipBox":"_h-tooltipBox-1004","profileTooltipBox":"_h-profileTooltipBox-61d2","profileTooltipBoxHover":"_h-profileTooltipBoxHover-696b","tooltipBoxHover":"_h-tooltipBoxHover-52ca","badge":"_h-badge-427a","cartBadge":"_h-cartBadge-5a49","badgeStories":"_h-badgeStories-5c90","cartBadgeStories":"_h-cartBadgeStories-3a3b"};

var PRICE_CLUB_QUERY = gql(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  query PRICE_CLUB_QUERY {\n    priceClub {\n      superPointBalance {\n        balance\n        balanceInEuro\n      }\n      isSubscribed\n      rank\n    }\n  }\n"], ["\n  query PRICE_CLUB_QUERY {\n    priceClub {\n      superPointBalance {\n        balance\n        balanceInEuro\n      }\n      isSubscribed\n      rank\n    }\n  }\n"])));
var STATUS_LINK_MEMBER = '/user/club';
var STATUS_LINK_NOT_MEMBER = '/event/club-rakuten';
var capitalize = function (str) {
    if (typeof str !== 'string')
        return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var formatPrice = function (price) {
    if (price && price >= 0) {
        return "".concat(price.toFixed(2)).replace('.', ',');
    }
    return '0,00';
};
var ClubRTooltip = function () {
    var _a = useQuery(PRICE_CLUB_QUERY), loading = _a.loading, data = _a.data;
    if (loading) {
        return (React.createElement("div", { className: "".concat(canopyStyle.flex, "\n       ").concat(canopyStyle['items-center'], "\n       ").concat(canopyStyle['justify-center'], "\n       ").concat(canopyStyle['pointer'], "\n       ").concat(s$7.chip) },
            React.createElement(ClubR, { width: '51px', height: '14px' })));
    }
    var status;
    var superPoints;
    var statusLink = STATUS_LINK_NOT_MEMBER;
    if (data && data.priceClub) {
        if (data.priceClub.isSubscribed) {
            statusLink = STATUS_LINK_MEMBER;
        }
        status = {
            icon: data.priceClub.rank.toLowerCase(),
            link: statusLink,
            label: 'Votre statut actuel',
            linklabel: capitalize(data.priceClub.rank.toLowerCase()),
            kind: data.priceClub.rank.toLowerCase(),
        };
        superPoints = {
            isSubscribed: data.priceClub.isSubscribed,
            link: STATUS_LINK_MEMBER,
            label: 'Rakuten Points utilisables :',
            linklabel: "(soit ".concat(formatPrice(data.priceClub.superPointBalance.balanceInEuro), ")"),
            valueInEuro: "".concat(formatPrice(data.priceClub.superPointBalance.balanceInEuro)),
            value: data.priceClub.superPointBalance.balance,
        };
        // showSuperPoints = {
        //   link: STATUS_LINK_MEMBER,
        //   label: 'Voir mes Rakuten Points',
        // };
    }
    return (React.createElement("div", { className: "".concat(s$7.clubRTapzone, " ").concat(canopyStyle['bg-white']), "data-qa": "clubr-tooltip" },
        React.createElement(Tooltip, { tooltipVariants: "outlined", arrow: true, sx: {
                zIndex: 12070,
            }, placement: 'bottom', title: React.createElement("div", { className: "".concat(tooltipStyle.wrapper, " ").concat(tooltipStyle['wrapper-default'], " ").concat(canopyStyle.flex, " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['justify-center']), "data-qa": "clubr-tooltip-content" },
                React.createElement(Async, { promise: import('./ClubRTooltipContent-6737497b.js'), status: status, superPoints: superPoints })) },
            React.createElement("a", { href: "/user/club", className: "".concat(canopyStyle.flex, "\n           ").concat(canopyStyle['items-center'], "\n           ").concat(canopyStyle['justify-center'], "\n           ").concat(canopyStyle['pointer'], "\n           ").concat(s$7.chip), "data-qa": "clubr-tooltip-button" },
                React.createElement(ClubR, { width: '51px', height: '16px' })))));
};
var templateObject_1$4;

var FavoriteTooltip = function (_a) {
    var _b = _a.placement, placement = _b === void 0 ? 'bottom' : _b;
    var t = useTranslate('header').t;
    useEffect(function () {
        if (window.convertSpan) {
            window.convertSpan();
        }
    });
    return (React.createElement("div", { className: "".concat(tooltipStyle.tabZone, " ").concat(canopyStyle['bg-white'], " ").concat(canopyStyle['flex'], " ").concat(canopyStyle['relative']) },
        React.createElement(Tooltip, { arrow: true, tooltipVariants: "outlined", sx: {
                zIndex: 12070,
            }, placement: placement, title: React.createElement("div", { className: "".concat(tooltipStyle.wrapper) },
                React.createElement(LinkOrSpan, { hasUnderline: false, href: "/memo?action=list", className: "".concat(canopyStyle['hover-bg-light-gray'], " ").concat(canopyStyle['no-underline'], " ").concat(canopyStyle.db, " ").concat(canopyStyle['mid-gray'], " ").concat(tooltipStyle.line) },
                    React.createElement(Typography, { variant: "body-default-regular", color: colorPalette.gray800 }, t('favorites_tooltip_list_label'))),
                React.createElement(LinkOrSpan, { hasUnderline: false, href: "/product_alert?action=list", className: "".concat(canopyStyle['hover-bg-light-gray'], " ").concat(canopyStyle['no-underline'], " ").concat(canopyStyle.db, " ").concat(canopyStyle['mid-gray'], " ").concat(tooltipStyle.line) },
                    React.createElement(Typography, { variant: "body-default-regular", color: colorPalette.gray800 }, t('favorites_tooltip_alert_label')))) },
            React.createElement("a", { href: "/memo?action=list", className: "".concat(canopyStyle['flex'], " ").concat(canopyStyle['pointer'], " ").concat(canopyStyle['relative'], " ").concat(tooltipStyle.tooltipBoxHover) },
                React.createElement(Heart, null)))));
};

var s$6 = {"wrapper":"_h-wrapper-d67c","block":"_h-block-628c","mainBlock":"_h-mainBlock-11a3","button":"_h-button-0adc","line":"_h-line-8300","profile":"_h-profile-01c3","profileTooltipTitle":"_h-profileTooltipTitle-aa55","icon":"_h-icon-e552","ERROR":"_h-ERROR-ac13","NOTICE":"_h-NOTICE-2858","VALID":"_h-VALID-9b6d","title":"_h-title-1e2e"};

var PROFILE_QUERY = gql(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  query PROFILE_QUERY {\n    profile {\n      actionsTotalCount\n      firstNameOrPseudo\n      isPro\n      userId\n      notifications {\n        level\n        rawMessage\n        link\n      }\n    }\n  }\n"], ["\n  query PROFILE_QUERY {\n    profile {\n      actionsTotalCount\n      firstNameOrPseudo\n      isPro\n      userId\n      notifications {\n        level\n        rawMessage\n        link\n      }\n    }\n  }\n"])));
var ProfileTooltip = function (_a) {
    var conversationIsActive = _a.conversationIsActive, sellHomeRedirectionIsActive = _a.sellHomeRedirectionIsActive, merchantCenterIsActive = _a.merchantCenterIsActive, merchantCenterBetaTesters = _a.merchantCenterBetaTesters, displayLink = _a.displayLink, _b = _a.placement, placement = _b === void 0 ? 'bottom' : _b, actionsTotalCount = _a.actionsTotalCount, setActionsTotalCount = _a.setActionsTotalCount;
    var t = useTranslate('header').t;
    var _c = useState(false), isStorybook = _c[0], setIsStorybook = _c[1];
    useEffect(function () {
        if (window.convertSpan) {
            window.convertSpan();
        }
    }, []);
    var _d = useQuery(PROFILE_QUERY, {
        fetchPolicy: 'cache-and-network',
        onCompleted: function (result) {
            var _a, _b;
            setIsStorybook(((_a = result === null || result === void 0 ? void 0 : result.profile) === null || _a === void 0 ? void 0 : _a.firstNameOrPseudo) === 'Logged in user');
            setActionsTotalCount(((_b = result === null || result === void 0 ? void 0 : result.profile) === null || _b === void 0 ? void 0 : _b.actionsTotalCount) || 0);
        },
    }), loading = _d.loading, data = _d.data;
    return (React.createElement("div", { className: "".concat(tooltipStyle.tabZone, " ").concat(canopyStyle['bg-white'], " _hy ").concat(canopyStyle['flex'], " ").concat(canopyStyle['relative'], " ").concat(tooltipStyle.profileTooltipBox) },
        React.createElement(Tooltip, { tooltipVariants: "outlined", arrow: true, placement: placement, sx: {
                zIndex: 12070,
            }, title: React.createElement("div", { className: "".concat(tooltipStyle.wrapper, " ").concat(tooltipStyle['wrapper-default'], " ").concat(canopyStyle['flex'], " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['justify-center']) }, loading ? (React.createElement(CircularIndeterminateCustom, null)) : (React.createElement(Async, { promise: import('./ProfileTooltipContent-c31b1435.js'), merchantCenterBetaTesters: merchantCenterBetaTesters, sellHomeRedirectionIsActive: sellHomeRedirectionIsActive, conversationIsActive: conversationIsActive, merchantCenterIsActive: merchantCenterIsActive, displayLink: displayLink, data: data }))) },
            React.createElement("a", { href: "/user", className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['flex-spacing-1'], " ").concat(canopyStyle.pointer, " ").concat(canopyStyle['relative'], " ").concat(canopyStyle['no-underline'], " ").concat(canopyStyle['dark-gray'], " ").concat(tooltipStyle.profileTooltipBoxHover), "data-qa": "profile-tooltip-button" },
                Boolean(actionsTotalCount) && actionsTotalCount && actionsTotalCount > 0 && (React.createElement(Badge, { badgeContent: actionsTotalCount, color: "primary", showZero: false, className: isStorybook ? tooltipStyle.badgeStories : tooltipStyle.badge })),
                data && data.profile ? React.createElement(PersonCheck, { width: "24", height: "24" }) : React.createElement(Person, { width: "24", height: "24" }),
                React.createElement("div", { className: "".concat(s$6.title, " ").concat(tooltipStyle.tooltipTitleBox) }, data && data.profile ? (React.createElement("div", null,
                    React.createElement(Typography, { variant: "body-small-regular", className: canopyStyle['gray'] }, "Votre compte"),
                    React.createElement(Typography, { className: s$6.profileTooltipTitle, variant: "body-default-semibold" }, data.profile.firstNameOrPseudo))) : (React.createElement(Typography, { className: s$6.profileTooltipTitle, variant: "body-default-regular" }, t('profile_tooltip_connect_label'))))))));
};
var templateObject_1$3;

var SalesTooltipStatic = {
    sales: {
        labels: {
            large: 'Mettre en vente',
            small: 'Vendre',
        },
        link: '/v/vendre',
        sellHomeLink: '/seller/sell-form',
        icon: 'sell',
    },
    tooltip: {
        product: {
            label: 'Vendre un produit en tant que particulier',
            subLabel: 'Je dépose une annonce gratuitement',
            link: '/v/vendre',
            sellHomeLink: '/seller/sell-form',
        },
        tips: {
            label: 'Astuces vendeurs particuliers',
            link: '/event/astuces_vendeur',
        },
        professional: {
            label: 'Je suis un commerçant',
            subLabel: "J'ouvre un e-shop",
            link: '/seller/sell-register-pro',
            newLink: '/onboarding-pro/user-information',
        },
        proHelp: {
            label: 'Conseils pour les commerçants',
            link: 'https://global.fr.shopping.rakuten.com',
        },
    },
};

var SalesTooltip = function (_a) {
    var sellHomeRedirectionIsActive = _a.sellHomeRedirectionIsActive, onboardingProIsActive = _a.onboardingProIsActive;
    var _b = useState(false), isMobile = _b[0], setIsMobile = _b[1];
    var productLink = sellHomeRedirectionIsActive
        ? SalesTooltipStatic.tooltip.product.sellHomeLink
        : SalesTooltipStatic.tooltip.product.link;
    var proLink = onboardingProIsActive ? SalesTooltipStatic.tooltip.professional.newLink : SalesTooltipStatic.tooltip.professional.link;
    useEffect(function () {
        if (typeof window === 'undefined')
            return;
        var checkIsMobile = function () { return window.innerWidth < 992; };
        setIsMobile(checkIsMobile());
        var handleResize = function () { return setIsMobile(checkIsMobile()); };
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    useEffect(function () {
        if (window.convertSpan) {
            window.convertSpan();
        }
    });
    return (React.createElement("div", { className: "_hy ".concat(canopyStyle['bg-white'], " ").concat(canopyStyle.flex, " ").concat(canopyStyle.relative, " ").concat(tooltipStyle.tooltipBox) },
        React.createElement(Tooltip, { arrow: true, tooltipVariants: "outlined", sx: {
                zIndex: 12070,
            }, title: React.createElement("div", { className: tooltipStyle.wrapper },
                React.createElement("div", { className: "".concat(canopyStyle.mv2, " ").concat(canopyStyle['dark-gray']) },
                    React.createElement("a", { className: "".concat(canopyStyle['dark-gray'], " ").concat(canopyStyle['no-underline'], " ").concat(canopyStyle.db, " ").concat(canopyStyle['hover-bg-light-gray'], " ").concat(tooltipStyle.line), href: productLink },
                        React.createElement(Typography, { variant: "body-default-regular" },
                            React.createElement(T, { ns: "header", keyName: "sales_tooltip_product_label" }, SalesTooltipStatic.tooltip.product.label)),
                        React.createElement(Typography, { variant: "body-small-regular", color: colorPalette.gray500 },
                            React.createElement(T, { ns: "header", keyName: "sales_tooltip_product_sub_label" }, SalesTooltipStatic.tooltip.product.subLabel))),
                    React.createElement("a", { href: SalesTooltipStatic.tooltip.tips.link, className: "".concat(canopyStyle['dark-gray'], " ").concat(canopyStyle['no-underline'], " ").concat(canopyStyle.db, " ").concat(canopyStyle['hover-bg-light-gray'], " ").concat(tooltipStyle.line) },
                        React.createElement(Typography, { variant: "body-default-regular" }, SalesTooltipStatic.tooltip.tips.label)),
                    React.createElement("hr", { className: tooltipStyle.breakLine }),
                    React.createElement(LinkOrSpan, { className: "".concat(canopyStyle['dark-gray'], " ").concat(canopyStyle['no-underline'], " ").concat(canopyStyle.db, " ").concat(canopyStyle['hover-bg-light-gray'], " ").concat(tooltipStyle.line), hasUnderline: false, href: proLink },
                        React.createElement(Typography, { variant: "body-default-regular", color: colorPalette.gray1000 },
                            React.createElement(T, { ns: "header", keyName: "sales_tooltip_professional_label" }, SalesTooltipStatic.tooltip.professional.label)),
                        React.createElement(Typography, { variant: "body-small-regular", color: colorPalette.gray500 },
                            React.createElement(T, { ns: "header", keyName: "sales_tooltip_professional_sub_label" }, SalesTooltipStatic.tooltip.professional.subLabel))))) },
            React.createElement("div", { className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['flex-spacing-1'], " ").concat(canopyStyle.pointer, " ").concat(tooltipStyle.tooltipBoxHover) },
                React.createElement(Euro, { width: "24", height: "24" }),
                !isMobile && (React.createElement("div", { className: tooltipStyle.salesTooltipTitleBox },
                    React.createElement(Typography, { variant: "body-default-regular" }, SalesTooltipStatic.sales.labels.large)))))));
};

var CART_QUERY = gql(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  query CART_QUERY {\n    cartNotifications {\n      nbProducts\n    }\n    cart {\n      nbProducts\n      purchaseId\n      priceClubVisible\n      totalPriceWithoutShipping\n      totalPointsToEarnAsMoney\n      products {\n        advertId\n        headline\n        picture\n        productUrl\n        price\n        quantity\n        warranties {\n          price\n          title\n          warrantyRuleId\n        }\n      }\n    }\n    priceClub {\n      isSubscribed\n      superPointBalance {\n        balanceInEuro\n      }\n    }\n  }\n"], ["\n  query CART_QUERY {\n    cartNotifications {\n      nbProducts\n    }\n    cart {\n      nbProducts\n      purchaseId\n      priceClubVisible\n      totalPriceWithoutShipping\n      totalPointsToEarnAsMoney\n      products {\n        advertId\n        headline\n        picture\n        productUrl\n        price\n        quantity\n        warranties {\n          price\n          title\n          warrantyRuleId\n        }\n      }\n    }\n    priceClub {\n      isSubscribed\n      superPointBalance {\n        balanceInEuro\n      }\n    }\n  }\n"])));
var REMOVE_PRODUCT_MUTATION = gql(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  mutation removeItem($removeItemInput: RemoveItemInput!) {\n    removeItem(removeItemInput: $removeItemInput) {\n      nbProducts\n    }\n  }\n"], ["\n  mutation removeItem($removeItemInput: RemoveItemInput!) {\n    removeItem(removeItemInput: $removeItemInput) {\n      nbProducts\n    }\n  }\n"])));
var REMOVE_WARRANTY_MUTATION = gql(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  mutation removeWarranty($removeWarrantyInput: RemoveWarrantyInput!) {\n    removeWarranty(removeWarrantyInput: $removeWarrantyInput) {\n      nbProducts\n    }\n  }\n"], ["\n  mutation removeWarranty($removeWarrantyInput: RemoveWarrantyInput!) {\n    removeWarranty(removeWarrantyInput: $removeWarrantyInput) {\n      nbProducts\n    }\n  }\n"])));
var templateObject_1$2, templateObject_2$1, templateObject_3$1;

var CartTooltip = function (_a) {
    var _b;
    var _c = _a.placement, placement = _c === void 0 ? 'bottom-end' : _c, nbProducts = _a.nbProducts, setNbProducts = _a.setNbProducts;
    var sendEvent = useGTM().sendEvent;
    var _d = useState(false), shouldQuery = _d[0], setShouldQuery = _d[1];
    var _e = useState(nbProducts === 9999), isStorybook = _e[0], setIsStorybook = _e[1];
    var removeProduct = useMutation(REMOVE_PRODUCT_MUTATION)[0];
    var removeWarranty = useMutation(REMOVE_WARRANTY_MUTATION)[0];
    var _f = useQuery(CART_QUERY, {
        fetchPolicy: 'cache-and-network', // Doesn't check cache before making a network request need to be fresh for the product detail page with add to card case
        skip: !shouldQuery,
        onCompleted: function (result) {
            var _a, _b;
            setIsStorybook(((_a = result === null || result === void 0 ? void 0 : result.cart) === null || _a === void 0 ? void 0 : _a.nbProducts) === 9999);
            setNbProducts(((_b = result === null || result === void 0 ? void 0 : result.cart) === null || _b === void 0 ? void 0 : _b.nbProducts) || 0);
        },
    }), data = _f.data, loading = _f.loading, refetch = _f.refetch;
    useEffect(function () {
        setIsStorybook(nbProducts === 9999);
    }, [nbProducts]);
    var handleOpen = useCallback(function () {
        setShouldQuery(true);
    }, []);
    var onProductRemove = function (purchaseId, advertId) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedData, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    sendEvent({
                        event: 'headerArticleDeleteClick',
                        location_alias: 'header',
                        page_title: 'header',
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, removeProduct({
                            variables: {
                                removeItemInput: {
                                    purchaseId: purchaseId,
                                    advertId: advertId,
                                },
                            },
                        })];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, refetch()];
                case 3:
                    updatedData = (_b.sent()).data;
                    setNbProducts(((_a = updatedData === null || updatedData === void 0 ? void 0 : updatedData.cart) === null || _a === void 0 ? void 0 : _a.nbProducts) || 0);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    console.error('Failed to remove product:', error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onWarrantyRemove = function (purchaseId, advertId, warrantyRuleId) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedData, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // call xiti
                    sendEvent({
                        event: 'headerWarrantyDeleteClick',
                        location_alias: 'header',
                        page_title: 'header',
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, removeWarranty({
                            variables: {
                                removeWarrantyInput: {
                                    purchaseId: purchaseId,
                                    advertId: advertId,
                                    warrantyRuleId: warrantyRuleId,
                                },
                            },
                        })];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, refetch()];
                case 3:
                    updatedData = (_b.sent()).data;
                    setNbProducts(((_a = updatedData === null || updatedData === void 0 ? void 0 : updatedData.cart) === null || _a === void 0 ? void 0 : _a.nbProducts) || 0);
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _b.sent();
                    console.error('Failed to remove warranty:', error_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var isSubscribed = false;
    if ((_b = data === null || data === void 0 ? void 0 : data.priceClub) === null || _b === void 0 ? void 0 : _b.isSubscribed) {
        isSubscribed = true;
    }
    var priceClubVisible = true;
    if (data === null || data === void 0 ? void 0 : data.cart) {
        priceClubVisible = !!data.cart.priceClubVisible;
    }
    var cart = data === null || data === void 0 ? void 0 : data.cart;
    var hasProducts = (cart === null || cart === void 0 ? void 0 : cart.products) && Array.isArray(cart.products) && cart.products.length > 0;
    return (React.createElement("div", { className: "".concat(tooltipStyle.tabZone, " ").concat(canopyStyle['bg-white'], " ").concat(canopyStyle.flex, " ").concat(canopyStyle.relative) },
        React.createElement(Tooltip, { tooltipVariants: "outlined", arrow: true, placement: placement, lazy: false, sx: {
                zIndex: 12070,
            }, onOpen: handleOpen, title: React.createElement("div", { className: "".concat(tooltipStyle.wrapper, " ").concat(tooltipStyle['wrapper-default'], " ").concat(canopyStyle.flex, " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['justify-center']) }, loading ? (React.createElement(CircularIndeterminateCustom, null)) : !hasProducts ? (React.createElement(Async, { promise: import('./EmptyCart-9978ac60.js'), priceClubVisible: priceClubVisible, isSubscribed: isSubscribed })) : (React.createElement(Async, { promise: import('./FullCart-4e369e41.js'), isSubscribed: isSubscribed, onProductRemove: onProductRemove, onWarrantyRemove: onWarrantyRemove, purchaseId: cart === null || cart === void 0 ? void 0 : cart.purchaseId, products: (cart === null || cart === void 0 ? void 0 : cart.products) || [], totalPriceWithoutShipping: cart === null || cart === void 0 ? void 0 : cart.totalPriceWithoutShipping, totalPointsToEarnAsMoney: cart === null || cart === void 0 ? void 0 : cart.totalPointsToEarnAsMoney, priceClubVisible: cart === null || cart === void 0 ? void 0 : cart.priceClubVisible }))) },
            React.createElement("a", { href: "/cart?o=1", className: "".concat(canopyStyle.flex, " ").concat(canopyStyle.pointer, " ").concat(canopyStyle.relative, " ").concat(tooltipStyle.tooltipBoxHover) },
                nbProducts > 0 && (React.createElement(Badge, { badgeContent: nbProducts > 99 ? '99+' : nbProducts, color: "primary", className: isStorybook ? tooltipStyle.cartBadgeStories : tooltipStyle.cartBadge })),
                React.createElement(Cart, { height: '24', width: '24' })))));
};

var fullbooksCartGraphQL = {
    priceClub: {
        isSubscribed: true,
        superPointBalance: {
            balanceInEuro: 288.0,
        },
    },
    cart: {
        purchaseId: 156155240,
        nbProducts: 9999,
        priceClubVisible: true,
        totalPriceWithoutShipping: 56.62,
        totalPointsToEarnAsMoney: 1.44,
        products: [
            {
                warranties: [
                    {
                        price: 14.62,
                        title: 'Le service culture rapide',
                        warrantyRuleId: 334,
                    },
                ],
                price: 42,
                advertId: 4434938,
                headline: 'Bleach Tome 9 - Fourteen Days For Conspiracy',
                picture: '893748817',
                productUrl: '/offer/buy/49373629/Sebilo-Didier-Sonnets-D-ouessant-Livre.html',
                quantity: 1,
            },
        ],
    },
};

var emptyCartGraphQL = {
    priceClub: null,
    cart: null,
};

({
    request: {
        query: REMOVE_WARRANTY_MUTATION,
        variables: {
            removeWarrantyInput: {
                purchaseId: fullbooksCartGraphQL.cart.purchaseId,
                advertId: fullbooksCartGraphQL.cart.products[0].advertId,
                warrantyRuleId: fullbooksCartGraphQL.cart.products[0].warranties[0].warrantyRuleId,
            },
        },
    },
    result: {
        data: __assign({}, emptyCartGraphQL),
    },
});

var s$5 = {"wrapper":"_h-wrapper-f5fc","contentContainer":"_h-contentContainer-8c57","marquee":"_h-marquee-3c3c","textWrapper":"_h-textWrapper-83ee","fadeIn":"_h-fadeIn-2eae","fadeOut":"_h-fadeOut-b417","marqueeScroll":"_h-marqueeScroll-1c91","chevronButton":"_h-chevronButton-6b78","chevronLeft":"_h-chevronLeft-697c","chevronRight":"_h-chevronRight-0c14","responsiveText":"_h-responsiveText-b6ed"};

var PreHeader = function (_a) {
    var _b, _c, _d;
    var preHeader = _a.preHeader; _a.isMobile;
    var sendEvent = useGTM().sendEvent;
    var _f = useState(0), currentIndex = _f[0], setCurrentIndex = _f[1];
    var _g = useState(false), isTextOverflowing = _g[0], setIsTextOverflowing = _g[1];
    var _h = useState(false), isFading = _h[0], setIsFading = _h[1];
    var textRef = useRef(null);
    var containerRef = useRef(null);
    var intervalRef = useRef(null);
    useEffect(function () {
        var checkTextOverflow = function () {
            if (textRef.current && containerRef.current) {
                var textWidth = textRef.current.scrollWidth + 64;
                var containerWidth = containerRef.current.clientWidth;
                setIsTextOverflowing(textWidth > containerWidth);
            }
        };
        checkTextOverflow();
        window.addEventListener('resize', checkTextOverflow);
        return function () { return window.removeEventListener('resize', checkTextOverflow); };
    }, [currentIndex, preHeader]);
    useEffect(function () {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        if (isTextOverflowing && preHeader.length > 1) {
            intervalRef.current = setInterval(function () {
                handleNext(true);
            }, 10000);
        }
        return function () {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [isTextOverflowing, preHeader.length, currentIndex]);
    if (!preHeader || preHeader.length === 0) {
        return null;
    }
    var currentBanner = preHeader[currentIndex];
    var handleTransition = function (newIndex) {
        if (isFading)
            return;
        setIsFading(true);
        setTimeout(function () {
            setCurrentIndex(newIndex);
            setTimeout(function () {
                setIsFading(false);
            }, 150);
        }, 150);
    };
    var handlePrevious = function () {
        var newIndex = (currentIndex - 1 + preHeader.length) % preHeader.length;
        handleTransition(newIndex);
    };
    var handleNext = function (auto) {
        if (currentIndex === preHeader.length - 1) {
            if (auto && isTextOverflowing) {
                setCurrentIndex(0);
            }
            else if (!auto) {
                handleTransition(0);
            }
        }
        else {
            if (!auto) {
                handleTransition(currentIndex + 1);
            }
            else if (isTextOverflowing) {
                setCurrentIndex(currentIndex + 1);
            }
        }
    };
    return (React.createElement("div", { className: s$5.wrapper, "data-qa": "preheader" },
        preHeader.length > 1 && (React.createElement("button", { onClick: handlePrevious, className: "".concat(canopyStyle['absolute'], " ").concat(canopyStyle['flex'], " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['justify-center'], " ").concat(s$5.chevronButton, " ").concat(s$5.chevronLeft), "aria-label": "preheader-previous", disabled: isFading, "data-qa": "preheader-previous" },
            React.createElement(ChevronLeft, { width: 16, height: 16, fill: "white" }))),
        React.createElement("a", { className: s$5.contentContainer, ref: containerRef, href: ((_b = currentBanner === null || currentBanner === void 0 ? void 0 : currentBanner.creation) === null || _b === void 0 ? void 0 : _b.link) || '', onClick: function () {
                var _a, _b, _c;
                sendEvent({
                    event: 'preheader_click',
                    page_title: 'preheader',
                    location_alias: 'header',
                    text_mobile: (_a = currentBanner === null || currentBanner === void 0 ? void 0 : currentBanner.creation) === null || _a === void 0 ? void 0 : _a.text_mobile,
                    text_desktop: (_b = currentBanner === null || currentBanner === void 0 ? void 0 : currentBanner.creation) === null || _b === void 0 ? void 0 : _b.text_desktop,
                    link: (_c = currentBanner === null || currentBanner === void 0 ? void 0 : currentBanner.creation) === null || _c === void 0 ? void 0 : _c.link,
                });
            } },
            React.createElement("div", { ref: textRef, className: "".concat(s$5.textWrapper, " ").concat(isTextOverflowing ? s$5.marquee : '', " ").concat(isFading ? s$5.fadeOut : s$5.fadeIn) },
                React.createElement(Typography, { variant: "body-default-semibold", style: {
                        color: 'white',
                        '--mobile-text': "\"".concat(((_c = currentBanner === null || currentBanner === void 0 ? void 0 : currentBanner.creation) === null || _c === void 0 ? void 0 : _c.text_mobile) || '', "\""),
                        '--desktop-text': "\"".concat(((_d = currentBanner === null || currentBanner === void 0 ? void 0 : currentBanner.creation) === null || _d === void 0 ? void 0 : _d.text_desktop) || '', "\""),
                    }, className: s$5.responsiveText }),
                React.createElement(Typography, { variant: "body-default-regular", style: { color: 'white', textDecoration: 'underline' } }, "En profiter"))),
        preHeader.length > 1 && (React.createElement("button", { onClick: function () { return handleNext(false); }, className: "".concat(canopyStyle['absolute'], " ").concat(canopyStyle['flex'], " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['justify-center'], " ").concat(s$5.chevronButton, " ").concat(s$5.chevronRight), "aria-label": "preheader-next", disabled: isFading, "data-qa": "preheader-next" },
            React.createElement(ChevronRight, { width: 16, height: 16, fill: "white" })))));
};

var HeaderStatic = {
    logo: {
        link: '/',
        icon: 'https://fr.shopping.rakuten.com/visuels/0_content_square/autres/rakuten-logo7.svg',
    },
    menu: {
        labels: {
            large: 'Parcourir les catégories',
            small: 'Menu',
            close: 'Fermer',
        },
    },
    search: {
        placeholders: {
            small: 'Rechercher',
            large: 'Que cherchez-vous ?',
        },
        location: {
            main: 'Rechercher autour de moi',
            tooltip: {
                set: 'Vous recherchez uniquement des produits pouvant être retirés à moins de {radius} km de {locality}',
                link: 'Modifiez la ville ou la distance.',
                unset: "Cliquez sur 'autour de moi' pour ne voir que les produits en retrait chez le vendeur près de chez vous.",
            },
            modal: {
                title: 'Localisation',
                addressInputLabel: 'Adresse',
                radiusLabel: 'Rayon de recherche {radius} km',
                buttonFilterLabel: 'Valider',
            },
        },
    },
};

function buildJsonLdWebSite() {
    var context = { '@context': 'http://schema.org' };
    var type = { '@type': 'WebSite' };
    var name = { name: 'Rakuten' };
    var url = { url: 'https://fr.shopping.rakuten.com' };
    var structuredJsonLdWebSite = Object.assign({}, context, type, name, url);
    structuredJsonLdWebSite.potentialAction = {
        '@type': 'SearchAction',
        target: 'https://fr.shopping.rakuten.com/search/{search_term}',
        'query-input': 'required name=search_term',
    };
    return structuredJsonLdWebSite;
}
function getJsonLdWebSite() {
    return JSON.stringify(buildJsonLdWebSite(), null, ' ');
}

var s$4 = {"logo":"_h-logo-dfe1","preHeaderWrapper":"_h-preHeaderWrapper-0a01","gigabannerWrapper":"_h-gigabannerWrapper-3b43","header":"_h-header-3e50","headerZIndex":"_h-headerZIndex-cc8e","nav":"_h-nav-91f7","srOnly":"_h-srOnly-732e","flex_grow":"_h-flex_grow-3af3"};

var layout = {"header":"_h-header-a2f4","mainHeader":"_h-mainHeader-7bec","logoLink":"_h-logoLink-7a15","logo":"_h-logo-08ed","desktopLayout":"_h-desktopLayout-286e","desktopNav":"_h-desktopNav-41e9","mobileLayout":"_h-mobileLayout-827d","mobileMenuAndLogo":"_h-mobileMenuAndLogo-37c1","mobileButtonGroup":"_h-mobileButtonGroup-fee5","mobileSearch":"_h-mobileSearch-c9dd","mobileHighlights":"_h-mobileHighlights-873d"};

var HeaderLayout = function (_a) {
    var handlerFocus = _a.handlerFocus, isNav = _a.isNav; _a.isHome; var internalSearchIsActive = _a.internalSearchIsActive, persistedSearch = _a.persistedSearch, storeHelper = _a.storeHelper, categories = _a.categories, universe = _a.universe, searchHasFocus = _a.searchHasFocus, helpLink = _a.helpLink, conversationIsActive = _a.conversationIsActive, merchantCenterIsActive = _a.merchantCenterIsActive, onboardingProIsActive = _a.onboardingProIsActive, sellHomeRedirectionIsActive = _a.sellHomeRedirectionIsActive, displayLink = _a.displayLink, merchantCenterBetaTesters = _a.merchantCenterBetaTesters, personalized = _a.personalized, md = _a.md, preHeader = _a.preHeader, highlights = _a.highlights; _a.gigaBanner; var nbProducts = _a.nbProducts, actionsTotalCount = _a.actionsTotalCount, setNbProducts = _a.setNbProducts, setActionsTotalCount = _a.setActionsTotalCount;
    var isInFrenchPlatform = useMarketplace(['fr']).isInTargetMarkets;
    var _b = useState(false), menuOpened = _b[0], setMenuOpened = _b[1];
    var renderLogo = function () {
        return (React.createElement("a", { href: HeaderStatic.logo.link, title: "Rakuten", className: layout.logoLink },
            React.createElement(QaTracker, { tagName: glossaryTagQA.header.logo },
                React.createElement(SvgCompose, { className: "".concat(s$4.logo, " ").concat(layout.logo), iconUri: HeaderStatic.logo.icon, activeUri: HeaderStatic.logo.icon, alt: "Rakuten - Achat et vente en ligne de produits neufs et d'occasion", active: false, width: "156px", height: "48px" }),
                React.createElement(Typography, { variant: "body-default-regular", component: "span", className: s$4.srOnly }, "Rakuten group"))));
    };
    var microdataWebSite = getJsonLdWebSite();
    return (React.createElement("header", { "data-qa": "header", className: "".concat(layout.header, " ").concat(canopyStyle['bg-white'], " ").concat(s$4.headerZIndex) },
        React.createElement("div", { className: s$4.preHeaderWrapper }, isInFrenchPlatform && preHeader && preHeader.length > 0 && React.createElement(PreHeader, { preHeader: preHeader })),
        React.createElement("div", { className: "".concat(canopyStyle['b--gray-300'], " ").concat(layout.mainHeader) },
            React.createElement("div", { className: "".concat(layout.desktopLayout, " ").concat(canopyStyle.flex, " ").concat(canopyStyle['justify-between'], " ").concat(canopyStyle['items-center']) },
                renderLogo(),
                React.createElement(SearchWrapperBreakpointContextToProps, __assign({ handlerFocus: handlerFocus, isNav: isNav, internalSearchIsActive: internalSearchIsActive }, HeaderStatic.search, { persistedSearch: persistedSearch, storeHelper: storeHelper, disableSuggest: false })),
                React.createElement("div", { className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['gap-8']) },
                    isInFrenchPlatform && React.createElement(ClubRTooltip, null),
                    isInFrenchPlatform && (React.createElement(SalesTooltip, { sellHomeRedirectionIsActive: sellHomeRedirectionIsActive, onboardingProIsActive: onboardingProIsActive })),
                    React.createElement(ProfileTooltip, { conversationIsActive: conversationIsActive, merchantCenterIsActive: merchantCenterIsActive, merchantCenterBetaTesters: merchantCenterBetaTesters, sellHomeRedirectionIsActive: sellHomeRedirectionIsActive, displayLink: displayLink, actionsTotalCount: actionsTotalCount, setActionsTotalCount: setActionsTotalCount }),
                    React.createElement(FavoriteTooltip, { placement: "bottom-end" }),
                    React.createElement(CartTooltip, { placement: "bottom-end", nbProducts: nbProducts, setNbProducts: setNbProducts }))),
            React.createElement("div", { className: "".concat(layout.mobileLayout, " ").concat(canopyStyle.flex, " ").concat(canopyStyle['justify-between'], " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['w-100']) },
                React.createElement("div", { className: "".concat(layout.mobileMenuAndLogo, " ").concat(canopyStyle.flex, " ").concat(canopyStyle['items-center']) },
                    React.createElement("div", { className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle.pointer), onClick: function () { return setMenuOpened(!menuOpened); }, "data-qa": "mobileMenuButton" },
                        React.createElement(NavAndMenuCtn, { md: md, personalized: personalized, menu: { categories: categories }, helpLink: helpLink, conversationIsActive: conversationIsActive, merchantCenterIsActive: merchantCenterIsActive, onboardingProIsActive: onboardingProIsActive, merchantCenterBetaTesters: merchantCenterBetaTesters, universe: universe, storeHelper: storeHelper, displayLink: displayLink, highlights: highlights })),
                    renderLogo()),
                React.createElement("div", { className: "".concat(layout.mobileButtonGroup, " ").concat(canopyStyle.flex, " ").concat(canopyStyle['items-center'], " ").concat(layout.mobileButtonGroup) },
                    isInFrenchPlatform && React.createElement(ClubRTooltip, null),
                    React.createElement(ProfileTooltip, { placement: "bottom-end", conversationIsActive: conversationIsActive, merchantCenterIsActive: merchantCenterIsActive, merchantCenterBetaTesters: merchantCenterBetaTesters, sellHomeRedirectionIsActive: sellHomeRedirectionIsActive, displayLink: displayLink, actionsTotalCount: actionsTotalCount, setActionsTotalCount: setActionsTotalCount }),
                    React.createElement(CartTooltip, { placement: "bottom-end", nbProducts: nbProducts, setNbProducts: setNbProducts }))),
            React.createElement("div", { className: "".concat(layout.desktopNav, " ").concat(canopyStyle['w-100']) },
                React.createElement(NavAndMenuCtn, { md: md, personalized: personalized, menu: { categories: categories }, searchHasFocus: searchHasFocus, helpLink: helpLink, conversationIsActive: conversationIsActive, merchantCenterIsActive: merchantCenterIsActive, onboardingProIsActive: onboardingProIsActive, merchantCenterBetaTesters: merchantCenterBetaTesters, universe: universe, displayLink: displayLink, storeHelper: storeHelper, highlights: highlights })),
            React.createElement("div", { className: "".concat(layout.mobileSearch, " ").concat(canopyStyle.mt2) },
                React.createElement(SearchWrapperBreakpointContextToProps, { disableSuggest: !isInFrenchPlatform, placeholders: HeaderStatic.search.placeholders, location: HeaderStatic.search.location, handlerFocus: function () { }, storeHelper: storeHelper })),
            isInFrenchPlatform && (React.createElement("div", { className: "".concat(layout.mobileHighlights, " ").concat(canopyStyle['pa3']) },
                React.createElement(Highlights, { highlights: highlights })))),
        React.createElement("script", { type: "application/ld+json", "data-qa": "md_website", dangerouslySetInnerHTML: { __html: microdataWebSite } })));
};

var StoreHelper = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    function StoreHelper(state, dispatch, externals) {
        this.state = state;
        this.dispatch = dispatch;
        this.externals = externals || {};
        this.closeMenu = undefined;
    }
    StoreHelper.prototype.isHidden = function () {
        return this.state && typeof this.state.visible !== 'undefined' && this.state.visible === false;
    };
    StoreHelper.prototype.isVisible = function () {
        return !this.isHidden();
    };
    StoreHelper.prototype.setFocus = function (status) {
        this.dispatch(setFocus(status));
    };
    StoreHelper.prototype.hasNav = function (url) {
        return typeof this.externals.nav === 'string' && url.startsWith('/nav/');
    };
    StoreHelper.prototype.nav = function (url) {
        if (this.hasNav(url)) {
            this.dispatch({ type: this.externals.nav, url: url });
        }
    };
    StoreHelper.prototype.hasSearch = function (url) {
        return typeof this.externals.search === 'string' && (url.startsWith('/s/') || url.startsWith('/search/'));
    };
    StoreHelper.prototype.search = function (url) {
        if (this.hasSearch(url)) {
            this.dispatch({ type: this.externals.search, url: url });
        }
    };
    StoreHelper.prototype.defineCloseMenu = function (closeMenu) {
        this.closeMenu = closeMenu;
    };
    StoreHelper.prototype.doCloseMenu = function () {
        if (this.closeMenu) {
            this.closeMenu();
        }
    };
    return StoreHelper;
}());

var DEFAULT_BASE_URL = '/restpublic/tech-web';
var getBaseUrl = function () {
    if (typeof window !== 'undefined') {
        return "".concat(window.location.origin).concat(DEFAULT_BASE_URL);
    }
    return DEFAULT_BASE_URL;
};
var getMenuUrl = function (query) {
    var baseUrl = getBaseUrl();
    var url = "".concat(baseUrl, "/menu");
    return query ? "".concat(url, "?").concat(query) : url;
};
var fetchMenu = function () {
    var args_1 = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args_1[_i] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (debug) {
        var url, options, response, menu, err_1, error;
        if (debug === void 0) { debug = false; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = getMenuUrl();
                    options = {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                        },
                        credentials: 'same-origin',
                    };
                    if (debug) {
                        console.debug('Fetching menu from:', url, options);
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, options)];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("HTTP error! status: ".concat(response.status));
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    menu = _a.sent();
                    if (debug) {
                        console.debug('Menu fetched successfully:', menu);
                    }
                    return [2 /*return*/, { menu: menu }];
                case 4:
                    err_1 = _a.sent();
                    error = err_1.message || 'Unknown error occurred';
                    console.error("ERROR common_fo - menu ".concat(error, " url=").concat(url));
                    return [2 /*return*/, { error: error, menu: {} }];
                case 5: return [2 /*return*/];
            }
        });
    });
};

var personalizedFraments = {
    cart: gql(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    fragment HeaderCart on Cart {\n      nbProducts\n    }\n  "], ["\n    fragment HeaderCart on Cart {\n      nbProducts\n    }\n  "]))),
    cartNotifications: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fragment HeaderCartNotification on CartNotification {\n      nbProducts\n    }\n  "], ["\n    fragment HeaderCartNotification on CartNotification {\n      nbProducts\n    }\n  "]))),
    profile: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    fragment HeaderProfile on Profile {\n      firstNameOrPseudo\n      actionsTotalCount\n      isPro\n    }\n  "], ["\n    fragment HeaderProfile on Profile {\n      firstNameOrPseudo\n      actionsTotalCount\n      isPro\n    }\n  "]))),
    priceClub: gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    fragment HederPriceClub on Club {\n      isSubscribed\n    }\n  "], ["\n    fragment HederPriceClub on Club {\n      isSubscribed\n    }\n  "]))),
};
var Header = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var _j = _a.header, header = _j === void 0 ? {
        hasFocus: false,
        visible: true,
        persistedSearch: undefined,
        merchantCenterBetaTesters: [],
        featureFlipping: {
            obfuscation: {
                isActive: true,
            },
            sellHomeRedirection: {
                isActive: false,
            },
            onboardingPro: {
                isActive: false,
            },
        },
    } : _j, dispatch = _a.dispatch, _k = _a.externals, externals = _k === void 0 ? {} : _k, _l = _a.md, md = _l === void 0 ? { userAgent: '' } : _l, mdMatchesBrowser = _a.mdMatchesBrowser, _m = _a.navandsearch, navandsearch = _m === void 0 ? {} : _m, _o = _a.router, router = _o === void 0 ? {
        location: {
            pathname: '',
            search: '',
            hash: '',
            state: { toggleFiltersAndUniverses: false },
        },
    } : _o; _a.initalAction; var _p = _a.personalized, personalized = _p === void 0 ? {} : _p, _q = _a.data, data = _q === void 0 ? {
        isHome: false,
        helpLink: undefined,
        menu: { categories: [] },
    } : _q;
    var _r = useState(false), suggestOpen = _r[0], setSuggestOpen = _r[1];
    var _s = useState([]), categories = _s[0], setCategories = _s[1];
    var _t = useState(false), menuLoadTrigger = _t[0], setMenuLoadTrigger = _t[1];
    var _u = useState([]), highlights = _u[0], setHighlights = _u[1];
    var _v = useState([]), preHeader = _v[0], setPreHeader = _v[1];
    var _w = useState([]), gigaBanner = _w[0], setGigaBanner = _w[1];
    var _x = useState(0), nbProducts = _x[0], setNbProducts = _x[1];
    var _y = useState(0), actionsTotalCount = _y[0], setActionsTotalCount = _y[1];
    var storeHelperRef = useRef(new StoreHelper(header, dispatch, externals));
    useEffect(function () {
        var _a, _b, _c;
        if ((_a = personalized === null || personalized === void 0 ? void 0 : personalized.profile) === null || _a === void 0 ? void 0 : _a.actionsTotalCount) {
            setActionsTotalCount(personalized.profile.actionsTotalCount);
        }
        if ((_b = personalized === null || personalized === void 0 ? void 0 : personalized.cart) === null || _b === void 0 ? void 0 : _b.nbProducts) {
            setNbProducts(personalized.cart.nbProducts);
        }
        else if ((_c = personalized === null || personalized === void 0 ? void 0 : personalized.cartNotifications) === null || _c === void 0 ? void 0 : _c.nbProducts) {
            setNbProducts(personalized.cartNotifications.nbProducts);
        }
    }, [
        (_b = personalized === null || personalized === void 0 ? void 0 : personalized.profile) === null || _b === void 0 ? void 0 : _b.actionsTotalCount,
        (_c = personalized === null || personalized === void 0 ? void 0 : personalized.cart) === null || _c === void 0 ? void 0 : _c.nbProducts,
        (_d = personalized === null || personalized === void 0 ? void 0 : personalized.cartNotifications) === null || _d === void 0 ? void 0 : _d.nbProducts,
        setActionsTotalCount,
        setNbProducts,
    ]);
    useEffect(function () {
        var _a;
        var doCloseMenu = (_a = storeHelperRef.current) === null || _a === void 0 ? void 0 : _a.closeMenu;
        storeHelperRef.current = new StoreHelper(header, dispatch, externals);
        if (doCloseMenu) {
            storeHelperRef.current.defineCloseMenu(doCloseMenu);
        }
    }, [header, dispatch, externals]);
    useEffect(function () {
        setMenuLoadTrigger(false);
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            var script_1 = document.createElement('script');
            script_1.async = true;
            script_1.onload = function () {
                if (typeof (window === null || window === void 0 ? void 0 : window.convertSpan) === 'function') {
                    return window === null || window === void 0 ? void 0 : window.convertSpan();
                }
                return null;
            };
            document.body.appendChild(script_1);
            return function () {
                if (script_1.parentNode) {
                    script_1.parentNode.removeChild(script_1);
                }
            };
        }
    }, []);
    useEffect(function () {
        if (!menuLoadTrigger && mdMatchesBrowser && !md.isBot) {
            setMenuLoadTrigger(true);
            fetchMenu()
                .then(function (response) {
                var menu = response.menu || {};
                if (menu.categories) {
                    setCategories(menu.categories);
                }
            })
                .catch(function (error) {
                console.error('❌ Failed to load menu:', error);
            });
        }
    }, [menuLoadTrigger, mdMatchesBrowser, md.isBot]);
    var fetchMarketingData = useCallback(function (elementType) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("https://fr.shopping.rakuten.com/visuels/content-short/lucy/merchandising-campaigns/element_type_".concat(elementType, ".json"))];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("HTTP error! status: ".concat(response.status));
                    }
                    return [2 /*return*/, response.json()];
            }
        });
    }); }, []);
    useEffect(function () {
        var fetchMarketingContent = function () { return __awaiter(void 0, void 0, void 0, function () {
            var results, preHeader_1, highlights_1, gigaBanner_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (typeof getActiveBanners !== 'function' || typeof getActiveHighlights !== 'function' || typeof getActiveBanner !== 'function') {
                            console.warn('Marketing functions are not available. Skipping marketing content fetch.');
                            setPreHeader([]);
                            setHighlights([]);
                            setGigaBanner([]);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Promise.allSettled([
                                fetchMarketingData('18'), // preHeader
                                fetchMarketingData('21'), // highlights
                                fetchMarketingData('1'), // gigaBanner
                            ])];
                    case 1:
                        results = _a.sent();
                        if (results[0].status === 'fulfilled') {
                            preHeader_1 = getActiveBanners(results[0].value);
                            setPreHeader(preHeader_1);
                        }
                        else {
                            setPreHeader([]);
                        }
                        if (results[1].status === 'fulfilled') {
                            highlights_1 = getActiveHighlights(results[1].value);
                            setHighlights(highlights_1);
                        }
                        else {
                            setHighlights([]);
                        }
                        if (!(results[2].status === 'fulfilled')) return [3 /*break*/, 3];
                        return [4 /*yield*/, getFilteredCampaigns(results[2].value, true)];
                    case 2:
                        gigaBanner_1 = _a.sent();
                        setGigaBanner(gigaBanner_1 ? (Array.isArray(gigaBanner_1) ? gigaBanner_1 : [gigaBanner_1]) : []);
                        return [3 /*break*/, 4];
                    case 3:
                        setGigaBanner([]);
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.error('❌ Failed to fetch marketing content: ', error_1);
                        setPreHeader([]);
                        setHighlights([]);
                        setGigaBanner([]);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        fetchMarketingContent();
    }, [fetchMarketingData]);
    var getUniverse = useCallback(function () {
        if (data && data.isHome) {
            return undefined;
        }
        if (navandsearch && navandsearch.result) {
            if (navandsearch.result.params && navandsearch.result.params.universe) {
                return navandsearch.result.params.universe;
            }
        }
        return '';
    }, [data, navandsearch]);
    var handlerFocus = useCallback(function (booleanStatus) {
        setSuggestOpen(booleanStatus);
    }, []);
    var getCommonProps = useCallback(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var universe = getUniverse();
        var isObfuscationActive = true;
        if (header && header.featureFlipping && header.featureFlipping.obfuscation) {
            isObfuscationActive = !!header.featureFlipping.obfuscation.isActive;
        }
        var displayLink = isObfuscationActive || universe === undefined;
        var finalCategories = Array.isArray((_a = data === null || data === void 0 ? void 0 : data.menu) === null || _a === void 0 ? void 0 : _a.categories) && data.menu.categories.length > 0 ? data.menu.categories : categories;
        var conversationIsActive = false;
        var sellHomeRedirectionIsActive = false;
        var merchantCenterIsActive = (_d = (_c = (_b = header === null || header === void 0 ? void 0 : header.featureFlipping) === null || _b === void 0 ? void 0 : _b.merchantCenter) === null || _c === void 0 ? void 0 : _c.isActive) !== null && _d !== void 0 ? _d : false;
        var onboardingProIsActive = (_g = (_f = (_e = header === null || header === void 0 ? void 0 : header.featureFlipping) === null || _e === void 0 ? void 0 : _e.onboardingPro) === null || _f === void 0 ? void 0 : _f.isActive) !== null && _g !== void 0 ? _g : false;
        if ((header === null || header === void 0 ? void 0 : header.featureFlipping) && (header === null || header === void 0 ? void 0 : header.featureFlipping.conversation)) {
            conversationIsActive = (_h = header === null || header === void 0 ? void 0 : header.featureFlipping.conversation.isActive) !== null && _h !== void 0 ? _h : false;
        }
        if ((header === null || header === void 0 ? void 0 : header.featureFlipping) && (header === null || header === void 0 ? void 0 : header.featureFlipping.sellHomeRedirection)) {
            sellHomeRedirectionIsActive = (_j = header === null || header === void 0 ? void 0 : header.featureFlipping.sellHomeRedirection.isActive) !== null && _j !== void 0 ? _j : false;
        }
        return {
            isHome: data === null || data === void 0 ? void 0 : data.isHome,
            suggestOpen: suggestOpen,
            conversationIsActive: conversationIsActive,
            merchantCenterIsActive: merchantCenterIsActive,
            onboardingProIsActive: onboardingProIsActive,
            sellHomeRedirectionIsActive: sellHomeRedirectionIsActive,
            displayLink: displayLink,
            merchantCenterBetaTesters: (_k = header === null || header === void 0 ? void 0 : header.merchantCenterBetaTesters) !== null && _k !== void 0 ? _k : [],
            personalized: personalized,
            md: md,
            universe: universe,
            categories: finalCategories,
            helpLink: data === null || data === void 0 ? void 0 : data.helpLink,
            highlights: highlights,
            preHeader: preHeader,
            gigaBanner: gigaBanner,
            nbProducts: nbProducts,
            actionsTotalCount: actionsTotalCount,
            setNbProducts: setNbProducts,
            setActionsTotalCount: setActionsTotalCount,
        };
    }, [
        data,
        navandsearch,
        header,
        categories,
        suggestOpen,
        personalized,
        md,
        highlights,
        preHeader,
        gigaBanner,
        nbProducts,
        actionsTotalCount,
        setNbProducts,
        setActionsTotalCount,
    ]);
    var renderHeader = useCallback(function () {
        var _a, _b, _c;
        var commonProps = getCommonProps();
        var unifiedProps = __assign(__assign({}, commonProps), { handlerFocus: handlerFocus, isNav: (_c = (_b = (_a = navandsearch === null || navandsearch === void 0 ? void 0 : navandsearch.result) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.nav) !== null && _c !== void 0 ? _c : false, internalSearchIsActive: true, persistedSearch: header === null || header === void 0 ? void 0 : header.persistedSearch, storeHelper: storeHelperRef.current, searchHasFocus: header === null || header === void 0 ? void 0 : header.hasFocus });
        return React.createElement(HeaderLayout, __assign({}, unifiedProps));
    }, [getCommonProps, handlerFocus, navandsearch, header]);
    if (router) {
        if (!((_f = (_e = router === null || router === void 0 ? void 0 : router.location) === null || _e === void 0 ? void 0 : _e.state) === null || _f === void 0 ? void 0 : _f.toggleFiltersAndUniverses)) {
            if (data && (header === null || header === void 0 ? void 0 : header.visible)) {
                return renderHeader();
            }
        }
    }
    else if (!((_h = (_g = navandsearch === null || navandsearch === void 0 ? void 0 : navandsearch.result) === null || _g === void 0 ? void 0 : _g.mob) === null || _h === void 0 ? void 0 : _h.toggleFiltersAndUniverses)) {
        if (data && (header === null || header === void 0 ? void 0 : header.visible)) {
            return renderHeader();
        }
    }
    return React.createElement(React.Fragment, null);
};
Header.personalizedFraments = personalizedFraments;
var templateObject_1$1, templateObject_2, templateObject_3, templateObject_4;

var aboutCompany_label = "Plus de services";
var aboutFr_label = "À propos de Rakuten";
var aquafadas_label = "Éditeur de logiciels et d'applications mobiles";
var auto_translation_label = "Traduisez automatiquement les descriptions et les avis depuis le français";
var auto_translation_status = "Traduction {status}";
var bank_label = "Services bancaires";
var cart_label_default = "Panier";
var cart_quantity_label = "Quantité : {quantity}";
var cart_tooltip_checkout_button_label = "Voir mon Panier";
var cart_tooltip_empty_label = "Votre Panier est vide";
var cart_tooltip_fee_label = "Hors frais de livraison";
var cart_tooltip_membership_label = "Devenir membre gratuitement";
var cart_tooltip_price_club_label = "Avantage membre : ";
var cart_tooltip_price_club_label_refund = "remboursés";
var cart_tooltip_refund_money_label = "offerts sur vos prochains achats";
var cart_tooltip_total_label = "Total Panier";
var change_langue = "Traduction";
var favorites_large = "Mes favoris";
var favorites_small = "Favoris";
var favorites_tooltip_alert_label = "Créer une alerte prix (souhait)";
var favorites_tooltip_list_label = "Voir ma liste de favoris";
var header_search_location_main = "Rechercher autour de moi";
var header_search_location_tooltip_link = "Modifiez la ville ou la distance.";
var header_search_location_tooltip_set = "Vous recherchez uniquement des produits pouvant être retirés à moins de {radius}  km de  {locality}";
var header_search_location_tooltip_title = "Filtres activés";
var header_search_location_tooltip_unset = "\"Cliquez sur 'autour de moi' pour ne voir que les produits en retrait chez le vendeur près de chez vous.";
var header_search_modal_address_input_label = "Adresse";
var header_search_modal_button_filter_label = "Valider";
var header_search_modal_radius_label = "Rayon de recherche {radius} km";
var header_search_modal_title = "Localisation";
var header_search_placeholders_large = "Que cherchez-vous ?";
var header_search_placeholders_small = "Rechercher";
var help_large = "Aide";
var help_small = "Aide";
var kobo_label = "Liseuses et applications de lecture";
var menu_close = "Fermer";
var menu_large = "Parcourir les catégories";
var menu_small = "Menu";
var price_club_tooltip_description = "Avec le Club R, 5% de cashback* sur tous vos achats de produits neufs ou d'occasion.";
var price_club_tooltip_discover_label = "Découvrez le Club R";
var price_club_tooltip_evrywhere_description = "Jusqu'à 20% de cashback* sur plus de 2000 sites";
var price_club_tooltip_evrywhere_label = "Commandez sur un site partenaire";
var price_club_tooltip_giftcard_description = "jusqu'à 10% de cashback* chez 100 enseignes";
var price_club_tooltip_giftcard_label = "Cartes cadeaux et bons d'achat";
var price_club_tooltip_sponsorship_description = "1 ami invité, 5€ gagnés";
var price_club_tooltip_sponsorship_label = "Parrainez un ami";
var price_club_tooltip_status_details_label = "Voir les détails";
var price_club_tooltip_status_label = "Statut";
var price_club_tooltip_status_label_use = "à utiliser";
var profile_large = "Se connecter";
var profile_small = "Compte";
var profile_tooltip_account_messagerie_label = "Mes Messages";
var profile_tooltip_account_notification_label = "Vos notifications";
var profile_tooltip_account_orders_label = "Suivi de commande";
var profile_tooltip_account_sponsorship_label = "Parrainage";
var profile_tooltip_account_title_label = "Mon compte";
var profile_tooltip_account_wallet_label = "Mon porte-monnaie";
var profile_tooltip_connect_label = "Se connecter";
var profile_tooltip_logout_label = "Déconnexion";
var profile_tooltip_sales_all_label = "Toutes mes ventes";
var profile_tooltip_sales_items_label = "Mes articles en vente";
var profile_tooltip_sales_merchant_center_label = "Espace vendeur";
var profile_tooltip_sales_product_label = "Mettre en vente un produit";
var sales_large = "Mettre en vente";
var sales_small = "Vendre";
var sales_tooltip_label = "Mettre en vente";
var sales_tooltip_pro_help_label = "Conseils pour les commerçants";
var sales_tooltip_product_label = "Vendre un produit en tant que particulier";
var sales_tooltip_product_sub_label = "Je dépose une annonce gratuitement";
var sales_tooltip_professional_label = "Je suis un commerçant\n";
var sales_tooltip_professional_sub_label = "J'ouvre un e-shop";
var sales_tooltip_tips_label = "Astuces vendeurs particuliers";
var sister_title = "Les autres services Rakuten";
var test = "Bonjour";
var travel_label = "Réservation de voyages en ligne";
var viber_label = "Service de messagerie et d'appels gratuits";
var viki_label = "Service de vidéo à la demande";
var wuaki_label = "Service de vidéo à la demande";
var frFR = {
	aboutCompany_label: aboutCompany_label,
	aboutFr_label: aboutFr_label,
	aquafadas_label: aquafadas_label,
	auto_translation_label: auto_translation_label,
	auto_translation_status: auto_translation_status,
	bank_label: bank_label,
	cart_label_default: cart_label_default,
	cart_quantity_label: cart_quantity_label,
	cart_tooltip_checkout_button_label: cart_tooltip_checkout_button_label,
	cart_tooltip_empty_label: cart_tooltip_empty_label,
	cart_tooltip_fee_label: cart_tooltip_fee_label,
	cart_tooltip_membership_label: cart_tooltip_membership_label,
	cart_tooltip_price_club_label: cart_tooltip_price_club_label,
	cart_tooltip_price_club_label_refund: cart_tooltip_price_club_label_refund,
	cart_tooltip_refund_money_label: cart_tooltip_refund_money_label,
	cart_tooltip_total_label: cart_tooltip_total_label,
	change_langue: change_langue,
	favorites_large: favorites_large,
	favorites_small: favorites_small,
	favorites_tooltip_alert_label: favorites_tooltip_alert_label,
	favorites_tooltip_list_label: favorites_tooltip_list_label,
	header_search_location_main: header_search_location_main,
	header_search_location_tooltip_link: header_search_location_tooltip_link,
	header_search_location_tooltip_set: header_search_location_tooltip_set,
	header_search_location_tooltip_title: header_search_location_tooltip_title,
	header_search_location_tooltip_unset: header_search_location_tooltip_unset,
	header_search_modal_address_input_label: header_search_modal_address_input_label,
	header_search_modal_button_filter_label: header_search_modal_button_filter_label,
	header_search_modal_radius_label: header_search_modal_radius_label,
	header_search_modal_title: header_search_modal_title,
	header_search_placeholders_large: header_search_placeholders_large,
	header_search_placeholders_small: header_search_placeholders_small,
	help_large: help_large,
	help_small: help_small,
	kobo_label: kobo_label,
	menu_close: menu_close,
	menu_large: menu_large,
	menu_small: menu_small,
	price_club_tooltip_description: price_club_tooltip_description,
	price_club_tooltip_discover_label: price_club_tooltip_discover_label,
	price_club_tooltip_evrywhere_description: price_club_tooltip_evrywhere_description,
	price_club_tooltip_evrywhere_label: price_club_tooltip_evrywhere_label,
	price_club_tooltip_giftcard_description: price_club_tooltip_giftcard_description,
	price_club_tooltip_giftcard_label: price_club_tooltip_giftcard_label,
	price_club_tooltip_sponsorship_description: price_club_tooltip_sponsorship_description,
	price_club_tooltip_sponsorship_label: price_club_tooltip_sponsorship_label,
	price_club_tooltip_status_details_label: price_club_tooltip_status_details_label,
	price_club_tooltip_status_label: price_club_tooltip_status_label,
	price_club_tooltip_status_label_use: price_club_tooltip_status_label_use,
	profile_large: profile_large,
	profile_small: profile_small,
	profile_tooltip_account_messagerie_label: profile_tooltip_account_messagerie_label,
	profile_tooltip_account_notification_label: profile_tooltip_account_notification_label,
	profile_tooltip_account_orders_label: profile_tooltip_account_orders_label,
	profile_tooltip_account_sponsorship_label: profile_tooltip_account_sponsorship_label,
	profile_tooltip_account_title_label: profile_tooltip_account_title_label,
	profile_tooltip_account_wallet_label: profile_tooltip_account_wallet_label,
	profile_tooltip_connect_label: profile_tooltip_connect_label,
	profile_tooltip_logout_label: profile_tooltip_logout_label,
	profile_tooltip_sales_all_label: profile_tooltip_sales_all_label,
	profile_tooltip_sales_items_label: profile_tooltip_sales_items_label,
	profile_tooltip_sales_merchant_center_label: profile_tooltip_sales_merchant_center_label,
	profile_tooltip_sales_product_label: profile_tooltip_sales_product_label,
	sales_large: sales_large,
	sales_small: sales_small,
	sales_tooltip_label: sales_tooltip_label,
	sales_tooltip_pro_help_label: sales_tooltip_pro_help_label,
	sales_tooltip_product_label: sales_tooltip_product_label,
	sales_tooltip_product_sub_label: sales_tooltip_product_sub_label,
	sales_tooltip_professional_label: sales_tooltip_professional_label,
	sales_tooltip_professional_sub_label: sales_tooltip_professional_sub_label,
	sales_tooltip_tips_label: sales_tooltip_tips_label,
	sister_title: sister_title,
	test: test,
	travel_label: travel_label,
	viber_label: viber_label,
	viki_label: viki_label,
	wuaki_label: wuaki_label
};

var staticData = {
    'es-ES:header': function () { return import('./es-ES-d2301ac4.js'); },
    'fr-FR:header': frFR,
    'pt-PT:header': function () { return import('./pt-PT-a1d88141.js'); },
    'it-IT:header': function () { return import('./it-IT-e4b91df5.js'); },
};

var initalAction = function (watchContext) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var isHome, helpLink, language, tolgee, staticDataSSR;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isHome = false;
                    if (watchContext && watchContext.page === 'home') {
                        isHome = true;
                    }
                    helpLink = '/newhelp/';
                    if (watchContext && watchContext.page === 'homePageVendre') {
                        helpLink = '/event/astuces_vendeur?xtatc=PUB-[PMC]-[V]-[home-vendre]-[aide]-[astuces-vendeurs]-[]-[]';
                    }
                    dispatch(setIsHome(isHome));
                    dispatch(setHelpLink(helpLink));
                    if (!(typeof window === 'undefined')) return [3 /*break*/, 2];
                    language = getLanguageFromRequest(watchContext.req);
                    tolgee = getTolgee({
                        language: language,
                        staticData: staticData,
                        ns: ['header'],
                    });
                    return [4 /*yield*/, tolgee.loadRequired({ language: language })];
                case 1:
                    staticDataSSR = _a.sent();
                    dispatch(tolgeeModule.actions.addTolggeStaticData(staticDataSSR));
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
};

var TitleNotification = function (_a) {
    var _b = _a.actionsTotalCount, actionsTotalCount = _b === void 0 ? 0 : _b;
    useEffect(function () {
        var currenttitel = document.title;
        var notificationRemovedTitel = currenttitel.replace(/^\(\d+\) - /g, '');
        if (actionsTotalCount) {
            var titelWithNotifications = "(".concat(actionsTotalCount, ") - ").concat(notificationRemovedTitel);
            document.title = titelWithNotifications;
        }
        else {
            document.title = notificationRemovedTitel;
        }
    }, [actionsTotalCount]);
    return null;
};

/**
 * header is the redux managed state for the header
 * externals is actions provided by "unknown" redux components and used by the header
 *
 * md is a props provided by the server as mobile detect info
 * data is a props passed to the Header component (historical reason)
 *
 * @param {*} state
 */
// @ts-expect-error ownProps
var mapStateToProps$1 = function (state, ownProps) {
    var _a, _b;
    // search among state any component implementing 'SEARCH', and 'PUSH_HISTORY'
    var externalReducxActions = {};
    Object.keys(state).forEach(function (key) {
        // @ts-expect-error keys
        if (state[key].actions) {
            // @ts-expect-error keys
            var actions = state[key].actions;
            if (actions.nav) {
                externalReducxActions.nav = actions.nav;
            }
            if (actions.search) {
                externalReducxActions.search = actions.search;
            }
        }
    });
    var data = {};
    if ((_a = state === null || state === void 0 ? void 0 : state.header) === null || _a === void 0 ? void 0 : _a.data) {
        // use state injected data else use from props
        data = __assign({}, state.header.data);
    }
    else if (ownProps.data) {
        data = ownProps.data;
    }
    // header is the redux managed state for the header
    // md is provided by the server as mobile detect info
    // data is the previously data passed to the Header component
    // navandsearch is provided by the server
    return {
        header: state.header,
        externals: externalReducxActions,
        navandsearch: state.navandsearch,
        router: (_b = state === null || state === void 0 ? void 0 : state.router) !== null && _b !== void 0 ? _b : null,
        data: data,
        md: state.md,
    };
};
// @ts-expect-error initalAction
var mapDispatchToProps$1 = function (dispatch) { return ({
    // @ts-expect-error initalAction
    initalAction: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return dispatch(initalAction.apply(void 0, args));
    },
    dispatch: dispatch,
}); };
var HeaderWithGraphQl = function (_a) {
    var _b, _c, _d;
    var _e = _a.PERSONALIZED_QUERY, PERSONALIZED_QUERY = _e === void 0 ? null : _e, _f = _a.PERSONALIZED_QUERY_OPTION, PERSONALIZED_QUERY_OPTION = _f === void 0 ? {
        ssr: false,
        skip: true,
    } : _f, props = __rest(_a, ["PERSONALIZED_QUERY", "PERSONALIZED_QUERY_OPTION"]);
    var data;
    var headerModuleOnsiteJSApi = {
        onAddToCard: function () { },
    };
    var _g = useBreakpoint(), md = _g.md, mdMatchesBrowser = _g.mdMatchesBrowser;
    // const { PERSONALIZED_QUERY, PERSONALIZED_QUERY_OPTION } = props;
    if (PERSONALIZED_QUERY) {
        PERSONALIZED_QUERY_OPTION.skip = true;
        if (mdMatchesBrowser) {
            PERSONALIZED_QUERY_OPTION.skip = md.isBot; // not run the query if we are in a Browser in a bot
        }
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var queryResult_1 = useQuery(PERSONALIZED_QUERY, PERSONALIZED_QUERY_OPTION);
        data = queryResult_1.data;
        headerModuleOnsiteJSApi.onAddToCard = function () {
            try {
                queryResult_1.client.cache.evict({ fieldName: 'cart' });
                queryResult_1.client.cache.evict({ fieldName: 'cartNotifications' });
            }
            catch (e) {
                console.error('onAddToCard error ', e);
            }
        };
    }
    // api integration with the Product page add to card feature
    useEffect(function () {
        // @ts-expect-error RakutenHeaderModule
        window.RakutenHeaderModule = asyncLoadArrayProzessor(headerModuleOnsiteJSApi)(window.RakutenHeaderModule);
    }, []);
    var actionsTotalCount = 0;
    if (data && data.profile && data.profile.actionsTotalCount) {
        actionsTotalCount = data.profile.actionsTotalCount;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(GtmProvider, null,
            React.createElement(TolgeeProvider, { ns: ['header'], apiKey: (_c = (_b = publicRuntimeConfig.tolgee) === null || _b === void 0 ? void 0 : _b.apiKey) === null || _c === void 0 ? void 0 : _c['next-common'], apiUrl: (_d = publicRuntimeConfig.tolgee) === null || _d === void 0 ? void 0 : _d.apiUrl, staticData: staticData },
                React.createElement(MarketplaceProvider, null,
                    React.createElement(TitleNotification, { actionsTotalCount: actionsTotalCount }),
                    React.createElement(Header, __assign({}, props, { md: md, mdMatchesBrowser: mdMatchesBrowser, personalized: data })))))));
};
var ConnectedHeader = HideInWebviewHoc(connect(mapStateToProps$1, mapDispatchToProps$1)(memo(HeaderWithGraphQl)));
// @ts-expect-error ssr
ConnectedHeader.ssr = true;
ConnectedHeader.personalizedFraments = Header.personalizedFraments;
var HeaderContainer = ConnectedHeader;

var s$3 = {"logo":"_h-logo-ad98"};

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */
var RakutenIchiba = function (_a) {
    var width = _a.width, height = _a.height;
    return (React.createElement(SvgImg$1, { viewbox: "0 0 184 52", title: "logo / rakutenIchiba", width: width, height: height, preserveAspectRatio: "xMinYMin meet" },
        React.createElement("g", { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "logos-/-rakutenIchiba" },
                React.createElement("path", { d: "M67.3528 21.8669L80.1819 9.05803H70.9946L61.0788 18.9453V0H54.5876V36.3725H61.0788V24.7756L72.694 36.3725H81.8942L67.3528 21.8669ZM124.432 28.7688C123.988 29.8729 122.915 30.5955 121.723 30.5932C120.935 30.5898 120.18 30.273 119.626 29.7128C119.072 29.1525 118.765 28.3951 118.772 27.6079C118.765 27.5187 118.765 27.4291 118.772 27.34V15.5773H128.355V9.05803H118.772V2.2071H112.28V9.01976H107.667V15.5773H112.28V27.34C112.139 32.0476 115.495 36.139 120.145 36.9294C124.795 37.7199 129.318 34.9675 130.744 30.4784L124.432 28.7688ZM44.1991 9.05803V10.3338C42.2973 9.1004 40.0779 8.44449 37.8101 8.44566C30.7439 8.44566 25.0321 14.8246 25.0321 22.7854C25.0321 30.7463 30.7822 37.1252 37.8101 37.1252C40.0782 37.1286 42.2982 36.4725 44.1991 35.237V36.4363H50.6903V9.05803H44.1991ZM31.485 22.7599C31.485 27.0465 34.3217 30.5677 37.8101 30.5677H37.874C41.3624 30.5677 44.263 27.0338 44.263 22.7599C44.263 18.486 41.3624 14.9649 37.874 14.9649C34.3856 14.9649 31.485 18.4733 31.485 22.7599ZM98.9017 9.05803V25.1711C99.0273 27.1428 98.0764 29.0284 96.4151 30.1018C94.7539 31.1752 92.6415 31.2689 90.8914 30.3469C89.1414 29.4249 88.0266 27.6309 87.9765 25.6559C87.9638 25.4946 87.9638 25.3325 87.9765 25.1711V9.05803H81.4725V25.1711C81.4597 29.3387 83.6287 33.2102 87.1923 35.3805C90.7559 37.5507 95.1962 37.7044 98.9017 35.7856V36.4363H105.406V9.05803H98.9017ZM166.076 9.72144C167.764 8.84106 169.64 8.38146 171.545 8.38187C178.154 8.3889 183.511 13.7368 183.518 20.3359V36.3725H177.014V20.3359C177.026 20.1703 177.026 20.004 177.014 19.8384C176.925 17.8876 175.8 16.1324 174.063 15.234C172.327 14.3355 170.242 14.4304 168.594 15.4827C166.947 16.5351 165.987 18.3851 166.076 20.3359V36.3725H159.584V9.05803H166.076V9.72144ZM156.978 22.7216C156.978 14.799 151.228 8.35635 144.2 8.35635C137.172 8.35635 131.422 14.6715 131.422 22.7216C131.44 30.3906 137.473 36.7006 145.145 37.0742C149.703 37.0868 153.954 34.7844 156.428 30.9632L150.691 27.7227C145.899 33.5658 139.191 29.5981 138.539 24.6481H156.863C156.934 24.0083 156.973 23.3653 156.978 22.7216ZM149.707 18.7922H138.795C139.97 13.485 148.506 12.4133 149.707 18.7922ZM6.49122 25.7963V36.3725H0V2.2071H10.7335C15.8861 2.18443 20.4571 5.50402 22.0223 10.4054C23.5875 15.3069 21.7846 20.6554 17.5697 23.6147L27.166 36.3725H19.0392L11.0913 25.7963H6.49122ZM6.49122 8.72633H10.7335C12.6465 8.60494 14.4762 9.52375 15.5192 11.1295C16.5621 12.7353 16.6559 14.778 15.7645 16.4723C14.873 18.1666 13.1352 19.2487 11.2191 19.3025C11.0575 19.3153 10.8951 19.3153 10.7335 19.3025H6.49122V8.72633ZM141.683 42.2574L42.2081 52L35.7161 42.2574H141.683Z", fill: "#BF0000" })))));
};

function Logo() {
    return (React.createElement("a", { className: s$3.logo, href: HeaderStatic.logo.link },
        React.createElement(RakutenIchiba, { width: "100%", height: "100%" })));
}

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */
var Account = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.fill, fill = _b === void 0 ? '#4A4A4A' : _b;
    return (React.createElement(SvgImg$1, { viewbox: "0 0 50 50", title: "app", width: width, height: height, preserveAspectRatio: "xMinYMin meet" },
        React.createElement("defs", null,
            React.createElement("path", { d: "M43.75,33.25 C41.1711677,30.9348419 38.3187688,28.9438928 35.256375,27.321525 C34.7892049,27.059467 34.4696465,26.5959216 34.3909044,26.0660896 C34.3121622,25.5362576 34.4831052,24.9998153 34.853875,24.613225 C37.284625,22.020775 38.5,19.833275 38.5,14 C38.6178911,11.1802753 37.5491837,8.44010441 35.5533459,6.44476546 C33.5575081,4.44942651 30.8170702,3.38140401 27.997375,3.5 C25.1784665,3.38253781 22.4392164,4.45110685 20.4444668,6.44635533 C18.4497171,8.4416038 17.381833,11.1811209 17.5,14 C17.5,19.833275 18.715375,22.020775 21.14595,24.613225 C21.5167198,24.9998153 21.6876628,25.5362576 21.6089206,26.0660896 C21.5301785,26.5959216 21.2106201,27.059467 20.74345,27.321525 C17.6811174,28.943905 14.8287779,30.9348537 12.25,33.25 C9.317875,36.182125 8.84205,42.798875 8.764875,48.9846 C8.75373131,49.9138803 9.11541519,50.8088765 9.76906764,51.4695009 C10.4227201,52.1301253 11.3138287,52.5012841 12.243175,52.5 L43.754725,52.5 C44.6843036,52.5014193 45.5757052,52.1303722 46.2297206,51.4697798 C46.883736,50.8091874 47.2458453,49.9141179 47.235125,48.9846 C47.15795,42.798875 46.682125,36.182125 43.75,33.25 Z M12.2647,49.028175 C12.298475,46.312525 12.40155,38.047975 14.72485,35.725025 C17.0647958,33.6269015 19.659139,31.831157 22.4469,30.38 C23.855545,29.593398 24.8224428,28.200837 25.0672176,26.6061243 C25.3119924,25.0114115 24.8072582,23.3929676 23.699375,22.2201 C21.97545,20.3805 21,19.0925 21,14 C20.8733222,12.1079497 21.5696682,10.2533301 22.9102936,8.91220177 C24.250919,7.57107347 26.1052773,6.87403188 27.997375,7 C29.8901518,6.87321053 31.7455053,7.56979709 33.0871515,8.91094032 C34.4287977,10.2520836 35.1260798,12.1071758 35,14 C35,19.0925 34.02455,20.3805 32.300275,22.21975 C31.1924824,23.3926985 30.6879141,25.0112009 30.9328991,26.605878 C31.1778841,28.200555 32.1450093,29.592966 33.5538,30.3793 C36.3412976,31.8308188 38.9353935,33.6267901 41.27515,35.725025 C43.598275,38.047975 43.701525,46.312525 43.754725,49 L12.2647,49.028175 Z", id: "account" })),
        React.createElement("g", { id: "Approche-aggressive", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "[DESK]-Type-default", transform: "translate(-991.000000, -1072.000000)" },
                React.createElement("g", { id: "Delivery", transform: "translate(468.000000, 997.000000)" },
                    React.createElement("g", { id: "Ship-+-delivery", transform: "translate(445.000000, 32.000000)" },
                        React.createElement("g", { id: "rexicon-32-domestic-area-l", transform: "translate(75.000000, 40.000000)" },
                            React.createElement("g", null,
                                React.createElement("rect", { id: "Rectangle-path", x: "0", y: "0", width: "56", height: "56" }),
                                React.createElement("mask", { id: "mask-2", fill: "white" },
                                    React.createElement("use", { xlinkHref: "#account" })),
                                React.createElement("use", { id: "Combined-Shape", fill: fill, fillRule: "nonzero", xlinkHref: "#account" }),
                                React.createElement("g", { id: "Color-/-Light-Grey", mask: "url(#mask-2)", fill: fill },
                                    React.createElement("rect", { id: "Rectangle-8", x: "0", y: "0", width: "55.7586207", height: "55.7586207" }))))))))));
};

var s$2 = {"profile":"_h-profile-d92c","flag":"_h-flag-4979"};

function notif(actionsTotalCount) {
    if (actionsTotalCount && actionsTotalCount > 0) {
        return React.createElement("div", { className: "".concat(canopyStyle.b, " ").concat(s$2.flag) }, actionsTotalCount);
    }
    return '';
}
function Profile(_a) {
    var firstNameOrPseudo = _a.firstNameOrPseudo, _b = _a.actionsTotalCount, actionsTotalCount = _b === void 0 ? 0 : _b;
    return (React.createElement(QaTracker, { customClass: "".concat(canopyStyle['ml-24'], " ").concat(canopyStyle['flex-ns'], " ").concat(canopyStyle['flex-column-ns'], " ").concat(canopyStyle.relative), tagName: glossaryTagQA.lightHeader.account },
        React.createElement("a", { className: "".concat(s$2.profile, " ").concat(canopyStyle['gray-800'], " ").concat(canopyStyle['no-underline']), href: NavStatic.profile.link },
            notif(actionsTotalCount),
            React.createElement(Account, { height: "24px", fill: "#4A4A4A" }),
            React.createElement("p", { className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['mt-8'], " ").concat(canopyStyle.f12) }, firstNameOrPseudo || NavStatic.profile.labels.large))));
}

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */
var HelpIcon = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.fill, fill = _b === void 0 ? '#4A4A4A' : _b;
    return (React.createElement(SvgImg$1, { viewbox: "0 0 26 25", title: "app", width: width, height: height, preserveAspectRatio: "xMinYMin meet" },
        React.createElement("svg", { width: "26", height: "25", viewBox: "0 0 26 25", fill: fill, xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M13 16.0625C12.3273 16.0625 11.7812 16.6085 11.7812 17.2812C11.7812 17.954 12.3273 18.5 13 18.5C13.6727 18.5 14.2188 17.954 14.2188 17.2812C14.2188 16.6085 13.6727 16.0625 13 16.0625Z", fill: fill }),
            React.createElement("path", { d: "M13 21.75C7.62369 21.75 3.25 17.3763 3.25 12C3.25 6.62369 7.62369 2.25 13 2.25C18.3763 2.25 22.75 6.62369 22.75 12C22.75 17.3763 18.3763 21.75 13 21.75ZM13 0.625C6.71775 0.625 1.625 5.71775 1.625 12C1.625 18.2822 6.71775 23.375 13 23.375C19.2822 23.375 24.375 18.2822 24.375 12C24.375 5.71775 19.2822 0.625 13 0.625Z", fill: fill }),
            React.createElement("path", { d: "M13 5.5C10.9809 5.5 9.34375 7.13719 9.34375 9.15625V9.5625H10.9688V9.15625C10.9688 8.03581 11.8796 7.125 13 7.125C14.1204 7.125 15.0312 8.03581 15.0312 9.15625C15.0312 10.2767 14.1204 11.1875 13 11.1875C12.5507 11.1875 12.1875 11.5507 12.1875 12V14.4375H13.8125V12.715C15.4391 12.3445 16.6562 10.8958 16.6562 9.15625C16.6562 7.13719 15.0191 5.5 13 5.5Z", fill: fill }))));
};

var s$1 = {"help":"_h-help-ff8e"};

function Help(_a) {
    var _b = _a.helpLink, helpLink = _b === void 0 ? NavStatic.help.link : _b;
    return (React.createElement(QaTracker, { customClass: "".concat(canopyStyle['flex-ns'], " ").concat(canopyStyle['flex-column-ns'], " ").concat(canopyStyle.relative, " ").concat(canopyStyle['ml-24']), tagName: glossaryTagQA.lightHeader.help },
        React.createElement("a", { className: "".concat(s$1.help, "  ").concat(canopyStyle['gray-800'], " ").concat(canopyStyle['no-underline']), href: helpLink },
            React.createElement(HelpIcon, { height: "24px", fill: "#4A4A4A" }),
            React.createElement("p", { className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['mt-8'], " ").concat(canopyStyle.f12) }, "Aide"))));
}

var s = {"nav":"_h-nav-4ff0","lightHeaderNav":"_h-lightHeaderNav-f059","loader":"_h-loader-93fd"};

function Nav(props) {
    var helpLink = props.helpLink, personalized = props.personalized, _a = props.hiddenClub, hiddenClub = _a === void 0 ? false : _a, _b = props.hiddenProfile, hiddenProfile = _b === void 0 ? false : _b;
    var actionsTotalCount = 0;
    var firstNameOrPseudo = undefined;
    if (personalized === null || personalized === void 0 ? void 0 : personalized.profile) {
        // eslint-disable-next-line prefer-destructuring
        actionsTotalCount = personalized.profile.actionsTotalCount;
        // eslint-disable-next-line prefer-destructuring
        firstNameOrPseudo = personalized.profile.firstNameOrPseudo;
    }
    return (React.createElement("nav", { className: s.lightHeaderNav },
        !hiddenClub && (React.createElement(QaTracker, { tagName: glossaryTagQA.lightHeader.clubR },
            React.createElement(ClubRTooltip, null))),
        React.createElement(Help, { helpLink: helpLink }),
        !hiddenProfile && React.createElement(Profile, { firstNameOrPseudo: firstNameOrPseudo, actionsTotalCount: actionsTotalCount })));
}

function LightHeader(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, helpLink = _a.helpLink, personalized = _a.personalized, hiddenClub = _a.hiddenClub, hiddenProfile = _a.hiddenProfile;
    if (visible) {
        return (React.createElement("header", { className: "".concat(canopyStyle['bg-white'], " ").concat(canopyStyle.relative, " ").concat(canopyStyle.bb, " ").concat(canopyStyle['b--gray-300'], " ").concat(canopyStyle['pv-16'], " ").concat(canopyStyle['pl-16-ns'], " ").concat(canopyStyle['pr-16-ns'], " ").concat(canopyStyle['ph-8']) },
            React.createElement("div", { className: "".concat(canopyStyle.grid_container) },
                React.createElement("div", { className: "".concat(canopyStyle.grid_row, " ").concat(canopyStyle['justify-between']) },
                    React.createElement("div", { className: "".concat(canopyStyle['grid_col-4-BelowDesktop'], " ").concat(canopyStyle.col_nogutter, " ").concat(canopyStyle.flex, " ").concat(canopyStyle['flex-column'], " ").concat(canopyStyle['justify-center']) },
                        React.createElement(Logo, null)),
                    React.createElement("div", { className: "".concat(canopyStyle['grid_col-2'], " ").concat(canopyStyle['grid_col-4-BelowMax'], " ").concat(canopyStyle['grid_col-8-BelowDesktop'], " ").concat(canopyStyle.col_nogutter) },
                        React.createElement(Nav, { helpLink: helpLink, personalized: personalized, hiddenClub: hiddenClub, hiddenProfile: hiddenProfile }))))));
    }
    return null;
}
LightHeader.personalizedFraments = {
    profile: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment HeaderProfile on Profile {\n      firstNameOrPseudo\n      actionsTotalCount\n    }\n  "], ["\n    fragment HeaderProfile on Profile {\n      firstNameOrPseudo\n      actionsTotalCount\n    }\n  "]))),
};
var templateObject_1;

/**
 * lightheader is the redux managed state for the header
 * externals is actions provided by "unknown" redux components and used by the header
 *
 * md is a props provided by the server as mobile detect info
 * data is a props passed to the Header component (historical reason)
 *
 * @param {*} state
 */
var mapStateToProps = function (state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var data = {};
    data = {
        visible: (_a = state === null || state === void 0 ? void 0 : state.header) === null || _a === void 0 ? void 0 : _a.visible,
        helpLink: (_b = state === null || state === void 0 ? void 0 : state.header) === null || _b === void 0 ? void 0 : _b.helpLink,
        logo: (_d = (_c = state === null || state === void 0 ? void 0 : state.header) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.logo,
        priceclub: (_f = (_e = state === null || state === void 0 ? void 0 : state.header) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.priceclub,
        profile: (_h = (_g = state === null || state === void 0 ? void 0 : state.header) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.profile,
        help: (_k = (_j = state === null || state === void 0 ? void 0 : state.header) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.help,
    };
    // lightheader is the redux managed state for the header
    // md is provided by the server as mobile detect info
    // data is the previously data passed to the Header component
    // navandsearch is provided by the server
    return __assign({}, data);
};
// default behavior for redux
var mapDispatchToProps = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
dispatch) { return ({
    // @ts-expect-error args
    initalAction: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return dispatch(initalAction.apply(void 0, args));
    },
    dispatch: dispatch,
}); };
var LightHeaderWithGraphQl = function (props) {
    var data;
    var PERSONALIZED_QUERY = props.PERSONALIZED_QUERY, _a = props.PERSONALIZED_QUERY_OPTION, PERSONALIZED_QUERY_OPTION = _a === void 0 ? { ssr: false } : _a;
    if (PERSONALIZED_QUERY) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var queryResult = useQuery(PERSONALIZED_QUERY, PERSONALIZED_QUERY_OPTION);
        data = queryResult.data;
    }
    var actionsTotalCount = 0;
    if (data && data.profile && data.profile.actionsTotalCount) {
        actionsTotalCount = data.profile.actionsTotalCount;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TitleNotification, { actionsTotalCount: actionsTotalCount }),
        React.createElement(LightHeader, __assign({}, props, { isEmbbedInBuyerApp: true }))));
};
var ConnectedLightHeader = connect(mapStateToProps, mapDispatchToProps)(LightHeaderWithGraphQl);
// @ts-expect-error ssr
ConnectedLightHeader.ssr = true;
ConnectedLightHeader.personalizedFraments = LightHeader.personalizedFraments;

var config = configService.get();
var NAME = 'header';
var DEFAULT_STATE$1 = {
    visible: true,
    persistedSearch: null,
    hasFocus: false,
    data: {},
    merchantCenterBetaTesters: config.merchantCenterBetaTesters,
    featureFlipping: {
        conversation: {
            isActive: config.featureFlipping.conversationIsActive,
        },
        merchantCenter: {
            isActive: config.featureFlipping.merchantCenterIsActive,
        },
        onboardingPro: {
            isActive: config.featureFlipping.merchantOnboardingIsActive,
        },
        sellHomeRedirection: {
            isActive: config.featureFlipping.sellHomeRedirectionIsActive,
        },
        obfuscation: {
            isActive: config.featureFlipping.obfuscation,
        },
    },
    marketplace: 'fr'
};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  NAME: NAME,
  DEFAULT_STATE: DEFAULT_STATE$1
});

var DEFAULT_STATE = DEFAULT_STATE$1;
function reducer(state, action) {
    if (state === void 0) { state = DEFAULT_STATE; }
    switch (action.type) {
        case SHOW:
            return __assign(__assign({}, state), { visible: true });
        case HIDE:
            return __assign(__assign({}, state), { visible: false });
        case PERSIST_SEARCH: {
            var persistedSearch = action.payload.length > 0 ? action.payload.join(' ') : null;
            return __assign(__assign({}, state), { persistedSearch: persistedSearch });
        }
        case FOCUSED:
            return __assign(__assign({}, state), { hasFocus: action.payload });
        // case FETCH_HEADER_SUCCESS:
        //   // data mod
        //   return {
        //     ...state,
        //     data: {
        //       ...state.data,
        //       ...action.payload,
        //     },
        //   };
        // case FETCH_HEADER_FAILURE:
        //   return {
        //     ...state,
        //     error: action.error, // fallback on error
        //     data: action.payload,
        //   };
        default:
            return state;
    }
}

var containers = { HeaderContainer: HeaderContainer, LightHeaderContainer: ConnectedLightHeader };
var headerModule = {
    containers: containers,
    constants: constants,
    reducer: reducer,
    initalAction: initalAction,
    actions: actions,
    tolgeeStaticData: staticData,
};

export { ChevronLeftIcon as C, SvgIcon24 as S, SvgCompose as a, SvgIcon as b, canopyStyle as c, SvgImg$1 as d, extractUniverse as e, s$6 as f, headerModule as h, s$7 as s, tooltipStyle as t };
